var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-3",
    d: "M94.41,298c-85.93,45-85.92,117.91,0,162.89s225.24,45,311.17,0,85.92-117.91,0-162.89S180.34,253,94.41,298Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pictures--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Frame--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "164.52 107.38 166.36 108.47 204.02 86.73 202.19 85.63 164.52 107.38",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.19 85.63 166.36 106.31 166.36 68.79 202.19 48.13 202.19 85.63",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.44,79.21a1.28,1.28,0,0,0-.58-1c-.22,0-.05-.73-.31-.59-.08,0-.05-.63-.18-.32-.09.69,0,1.21-.56.91-.18,0,.09-.58-.05-.51-.39.09-.44.31-.63.8-.33-.22-.41.55-.63.69,0,.57-.55.76-.77,1.18-.27.66.18,1.08.13,1.73s.77-.45.93-.74.62-.61.85-.42c0,.08.11.37.16.19.19-.41.11-.3.21-.11.17.68.6.44,1.07-.08A15.12,15.12,0,0,0,197.44,79.21Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.33,76.35c.14.28.25.23.56.15s0,.53.1.45c.45-.17.28,0,.68-.44.14,0,.24.33.4.06s-.18-.12-.18-.31.09-.23,0-.2c-.34-.06-.79-.45-1.14.22-.16.18,0-.36-.17-.28S195.21,76.31,195.33,76.35Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.63,79.87c-.19,0-.15.25-.25.45s-.33.42-.39.73.1.15.08.32c.05,0,.07-.12.13-.14C198.32,81,199,79.77,198.63,79.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.09,79.17c-.08-.08-.19.16-.24,0-.12.22-.19.5,0,.6C198.73,80.38,199.08,79.29,199.09,79.17Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,81.69c0-.27-.11-.09-.2,0C196.32,81.79,197,82.63,197,81.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.47,67.3c-.27-.11-.49.54-.71.4,0,0-.34.7-.29.38.37-.86-.2.09-.35.08.06-.17.25-.21.09-.27,1.4-1.27-1.69.16-1.94.82-.08.36-.28.14-.45.39.09.21.05.14-.11.13a.58.58,0,0,1-.26.09c-.17.13-1.46,1.51-1.12,1.54s-.51.6-.59.87.25,0,.24.17-.11.2,0,.2c.49.37,1.09-1.09,1.46.38-.09.34,0,.35.17.19.21.17-.46.57,0,.65,0,0,0,0,0-.07,0-.2.1.1.11-.18s.09,0,.06.14-.24.27-.27.55c.11.65.42,1.53,1,1.18.11-.49.21-.93.34-1.43a2,2,0,0,0,.68-1.06c.21-.22,1.37-1.22.58-.93.06-.11.08-.26.14-.35.05.11.38.17.29-.17-.07-.07-.36-.23-.06-.28,0,0,0,0,0-.08,0-.27-.33.36-.25,0,0-.18.12-.28.2-.19s.28-.21.14-.21,0-.11,0-.14c.39-.26-.27,0,.18-.46,0-.26-.19,0-.25-.12s.22-.36.28-.31c.23-.2-.29.08-.09-.15.09-.06,0-.06,0-.1s-.19.3-.2.12a2,2,0,0,1,.35-.85c0-.14-.18.2-.18,0,.48-.44,0-.14.37-.49C182.24,67.61,182.59,67.43,182.47,67.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.37,85.39c-.29.19-.33-.35-.59-.08s-.5-.12-.81.07c-.05-.29-.16-.65-.39-.62s-.09.15-.32.18c-.14-.24-.35-.17-.46-.41-.17,0-.34.29-.53.27-.1.16-.09-.14-.2,0,0-.07-.27.4-.25.16-.09,0-.38.34-.39.56-1.29,1.06-.32-.68-.91-.49-.2.21-.29.23-.31,0s.18-.26.14-.46.13-.19,0-.23c-.36,0-.42,1.06-.82.86a1.67,1.67,0,0,1,.24-1.84c.19,0,.34,0,.42-.34.78-.47.42.3.81.38.14-.5-.32-.79.08-1.29.22-.45.46-.64.28-1,0-.31.09.19.14-.24,0,0,.12-.42.19-.44.24-.19,0-.06.05-.15.29-.13.09-.31.28-.58s.53-.79.32-.25c.12.11.81-.75.58-.88-.13.11-.11.43-.28.38-.34.06,0-.6-.17-.54-.34.28-.5.52-.12-.11.24,0,.79-.72.85-.6-.33,1.06-.18.54.19.54s.23-.51-.06-.49c0-.19.07-.48,0-.67-.35-.3-.47,0-.66-.65-.21-1-.51,1-.66-.1,0-.19-.25,0-.31-.18s-.18.06-.29.1-.25.21-.26.51c.16.2-.12.45.14.63s-.18.54-.25.77.18.51-.06.7c-.17,0-.24-.29-.22-.65-.24.19-.41.07-.62,0s-.31.17-.35.08c.06-.4-.35,0-.19-.5,0-.46.58-1,.13-.94.12-.14.89-.55.31-.65.09-.2.26.14.33-.21-.1-.24.25-.15.39-.42s0-.34.08-.68c-.06,0-.3-.06-.13-.09a2.06,2.06,0,0,0,.45-.35c.18.08.15.18.18.43s.21-.07.09-.13c.06-.16.28,0,.27.09-.1.35-.14.12-.19.6-.5.17-.39.76,0,.23.19-.19.16.24.3.19s.67.17.4-.18c-.07-.1.15-.16.21-.22.12-.43-.34-.21-.27-.51s.3.16.38-.07c.66-1-.56-.34-.33-.71.06-.66-.7-.21-.93-.58-.35.09-1.45.23-1.24,1.24.1.29.35,0,.54,0-.28.14,0,.24-.13.39-.05.33-.19.09-.12.36s-.1,0-.13,0a.21.21,0,0,0,0-.29c-.16,0-.21.16-.28-.15-.46-.44-.05-.37,0-.84s-.6.05-.44.5c.12.12-.19.38-.08.52s0,.32-.16.32c-.25.53.08.11-.06.46s-1.17.61-.29,0c0-.27-.13,0,.09-.29-.33-.24-.44,0-.39-.85-.51.33-.18.57-.31.7,0-.2-.19-.35-.27,0,0,0-.18-.09-.22.06s-.08.16-.1.1c.19-.48-.46.2-.43.49.22.35.21.09.62,0,0,.23-.48.2-.48.49.37.09.63-.14,1-.24,0,.06-.16.16-.08.25s-.06.31,0,.15-.43.23-.62.2,0-.15,0-.23c-.25.1-.68,0-.87.28-.1.1-.11.05-.09-.07-.19.34-.17.13-.33,0-.11.44-.3.24-.5.56-.24,0-.23.35-.32.32a5.46,5.46,0,0,0-2.26.84c0,.21-.16.15-.22.31s-.15.46-.31.51.3.29.36.26c.18.22-.19.32-.29.26-.19.38-.4.28-.18.52s.59-.6.53-.05c0,.12-.1.12-.14.15s0,.16-.1.16-.31.55-.22.55,0,.18.11.15c0,.24.24-.09.25,0-.07.45.16-.09.24.06s.05,0,.05-.06c.23-.31.14.1.09.32a1.3,1.3,0,0,0,.43-.69c-.16,0,.1-.24.12-.37.11-.32.13.17,0,.22.12.14.21-.31.37-.32s0-.2.05-.28c.36.1,1-.41,1.23.24.33-.26,0,.56.3.15.18-.13.16.37.37.28,0,.4.1.51.34.6.13.65-.11,1.58.27,2,.19.33.51.3.61.81.24,0-.06.34.14.31s.13.09.16.24a.21.21,0,0,1,.2.14c.2,0-.41-.87-.42-.94-.09-.6.63.72.79.72.13.57.28.67.74.63.42-.23.69,0,1.06-.12.11.34.24.46.51.47.21.2.12-.19.28-.32.3.45.09.81-.16,1.54-.11.25.11.26,0,.36-.25.38.07.48.14.69.1,1,1,.57.8,1.84-.1,1.2-.27,2.32-.38,3.44.14.07,0-.23.13-.33.09.06,0,.31,0,.42,0,.29-.14.26-.2.55,0,.08.15,0,.07.16s0,.12-.06.13c-.13.21.1,0,0,.17-.08.38.1,0,0,.45.09,0,.16,0,.1.21.05,0,.24-.31.16-.1s.14-.08,0,.12,0,.25.09.31c.12-.1.3.08.27-.26,0-.05.16-.18.08-.16-.18.2-.11-.25-.16-.36-.11-.3.27-.69.3-1-.1-.07-.27-.09-.05-.36s.05-.41.22-.54-.12,0-.08-.18.1-.08.18-.19c.06-.59.42-.48.59-1-.09-.48-.14-.33.23-.54a5.1,5.1,0,0,0,.31-.84s0,.09.07,0,0-.07,0-.1c.26-1.75.61-1,1-2.24C180,85.9,180.42,86.49,180.37,85.39Zm-9.67-4.94s0,0,0,0Zm4.46-.59c.25-.58.37.06.55.07s.47-.11.27.13c-.15,0-.06.27-.16.39s0-.23-.08-.12,0-.27-.07-.23c-.3,0-.15.65-.32.83-.15-.1,0-.58,0-.81C175.21,80,174.54,80.71,175.16,79.86Zm-1.6-3.49s0,0,0,0S173.55,76.39,173.56,76.37Zm-1.62,1.76c.14-.29.05-.5.33-.59,0,.21.2-.13.22,0a5.21,5.21,0,0,1-.32.49c0,.08,0-.12-.09,0S171.9,78.25,171.94,78.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.55,72.67c.19,0,.48.39.73-.15.11.08-.07.3,0,.36s0,.05,0,.08c-.15.22-.31.45-.5.38-.71.32.23,0,.16.54.24-.12.48-.2.74-.3.09-.38.41,0,.44-.53-.16-.35-1,.82-.91.17.37-.25.77-.22,1.08-.69,0-.18-.27,0,0-.26.32-.5.25-.15.39-.83a6.36,6.36,0,0,0,.9-1.29c.91-.87-.48-.29-.79-.1s-.68.38-1,.84c-.16.09-.28.11-.35.39-.07,0-.49.31-.44.39.14-.24.15.41.42,0,0-.08.16.22.32-.12.12,0,.59-.6.38-.22s-.35.17-.19.43c-.12-.12-.72.09-.39.27.09-.1.12.16,0,.09s-.22.14-.22-.14c-.09-.11-.38,0-.54-.18C174.59,72,174.39,72.52,174.55,72.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.78,76.5c.3.41.52-.57.87-1-.16-.15-.54.06-.83.26C171.88,76.23,171.55,76.6,171.78,76.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.62,74.78a2.94,2.94,0,0,1-.12.4c.1.06.25-.19.32-.14-.15.42.29,0,.38-.18s.39-.14.43-.5c0-.18-.34.26-.28-.18-.34.11,0,.44-.2.5A.37.37,0,0,0,172.62,74.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.35,74.38c-.12.13-.49.38-.25.44-.07.09-.37.2-.16.3.49.49.71-.69.44-.42C174.2,74.71,174.54,74.56,174.35,74.38Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.38,76.5c.1,0,.21.1.31-.15s.21,0,.31-.19-.38-.08-.43-.31C175.42,76,175.47,76.3,175.38,76.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.06,75.18c.35-.05.31-.68.41-.33C173.17,73.7,171.71,75.23,172.06,75.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,84c.26-.53-.14-.64-.4-.38s-.63-.2-.71.22C176.3,84.16,177.07,83.24,177,84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.76,73.28c.18,0,0,.1-.07.19s.41,0,.54-.18C174.21,72.82,173.33,73.33,173.76,73.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.07,73.77c-.1.52,0,.17.11.4C174.47,74.19,174.33,73.54,174.07,73.77Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.29,77.31s0,0-.08,0S171.27,77.34,171.29,77.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.13,76.66c0-.27-.25-.24.06-.7-.21-.24-.27,0-.46.33-.13.16-.2.38-.33.58s-.2,0-.21.29c0,.5.49.7.72.2A1.8,1.8,0,0,1,194.13,76.66Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.28,69.1c-.14.16-.15,1-.34.86s0,.41-.39.5c-.52.69-.16.56.13.31,0-.07-.06-.26,0-.14s0,.08.08,0c.11-.25.4-.35.47-.6S196.53,69.15,196.28,69.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.66,62.84c.23-.08.67.24.74-.39.09-.34-.27.08-.22-.21C192.17,61.68,191.55,62.58,191.66,62.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,61.84c.17-.14.74-.32.65-.68C196.49,61,195.58,61.63,196,61.84Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.53,76.54c0-.24-.05-.14-.13,0-.27-.17-.25.79-.18,1,.16,0,0-.58.2-.22.13-.08.1-.31.07-.41S194.68,76.69,194.53,76.54Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.87,74.91c-.09.08-.34.39-.21,0,.12,0,.08-.13.16-.24s-.17,0-.06-.08,0,0,0,0c-.17-.27-.14,0-.1.2s-.3-.05-.17.22c.06,0,.07,0,0,.08.12.26-.06.17,0,.38.12-.19.11.13.25.14C194.85,75.27,195,75.28,194.87,74.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.31,63c.17-.11.52-.28.6-.58C192.72,62.11,192.39,62.48,192.31,63Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.71,68.31c-.49.31-.11-.68-.52.66,0,.21.13.08.1,0s0,0,0-.06S196.87,68.46,196.71,68.31Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.25,74.3c-.06.2.07.34.08.5.18,0,.12-.62.17-.83s-.24-.13-.2.08S194.34,74.23,194.25,74.3Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.38,66.92c.1.25-.09,1.31.11,1.1,0-.17-.1-.41.07-.54S196.43,66.1,196.38,66.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.5,78.33l.06,0C186.51,78.42,186.49,78.4,186.5,78.33Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.59,75.1v0S185.62,75.16,185.59,75.1Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.57,82.34c-.31,1-.52.48-.52,1.63-.19.47.17.92.37.38C187.42,83.76,187.93,82.53,187.57,82.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.22,80.47c1.21-3,.31-1.24-.21-1.33.1-.3-.23-.32-.31-.47a2.25,2.25,0,0,1-.29-.83c-.14-.12-.2-.47-.29-.7.22-.09.1-.36.11-.62a5.86,5.86,0,0,1-.89.47c-.18-.13-.52,0-.51.45-.22.25-.42-.19-.65,0,0,0-.11.07-.12,0s-.12.08-.11,0,0-.05.05-.06c.35-1.22-1.27.6-1.61.82-.16.44-.41.69-.36,1.1a4,4,0,0,0-.56,1.25c-.24.54.11.83-.13,1.39a2.07,2.07,0,0,0,.13.4c.22,0,.23.57.45.51.42.41,1-.48,1.41-.77.16-.17.15.24.3.12.21-.32.42.08.26.29-.13.75.39.69.39,1.54a5.17,5.17,0,0,0,.12,2.47c.38.67.12,1.48,1,.45a5.06,5.06,0,0,0,.82-2.49c-.08-.44.54-.78.54-1.24C186.72,82,186.38,81.83,187.22,80.47Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.94,61.3c-.15-.25-.33.24-.42.08-.09-.33-.44-.19-.64-.26s-.59.18-.84.36c-.12-.11-.18.09-.25.23s-.47.15-.52.38c0,0,0,0,0,0,0-.19-.13,0-.13-.12-.09-.58-.6.35-.81.1-.25.17-.21-.41-.48.13,0,.08-.09.15-.1.05-.05-.32-.39,0-.56.13s.12.13,0,.29-.49.23-.7.4c-.11.52-.44.19-.34-.18s-.51-.08-.49.18-.26.16-.38.28c-.28-.16-.43.16-.62.15.07-.11-.45.32-.29,0,.48-.57.29-1-.22-.56-.15.15-.24-.06-.33-.18-.25.13-.35.6-.48.75a3.4,3.4,0,0,0-.72.59c-.44.46-.25.34-.39.78-.19.12-.6.25-.49.58.07,0,.18,0,.14.15s-.48-.07-.45.14-.08,0-.1.15.34.12.07.19c-.36.27-.1-.53-.24-.17s-.23,0-.14.45c-.13.07-.15-.09-.11-.26.11-.42-.35-.15-.36.21s-.18.22-.1.44c-.14.38.14.18.13.48-.19.21-.45-.28-.71,0-.11.2-.27-.12-.31.17.06.08.22,0,.21.17s-.12,0-.23.16c-.28.42-.48.19-.76.56-.12.21-.24.4-.35.57s-.23-.08-.06-.22c.11-.35-.34-.11-.17.45a.74.74,0,0,0-.43.67c-.18.13-.49-.06-.23.28-.29.32-.2-.33-.37-.37s1-.17.66-.72a1.22,1.22,0,0,0-.92.07c-.11-.1.13-.37-.22-.24a1.41,1.41,0,0,0-.65.65c-.25.28-.11-.16-.44.43-.05.09,0,0,.06,0-.08.29-.16-.06-.27.28.16,0-.22,1-.31,1.06s-.23.43-.32.65c-.48.39-.25,1.8.19.81.25-.35.19.77.39.52.49-.61.08-.35.36-.93.21-.42-.23-.43,0-.9.13-.29.34-.46.33-.8.26-.4.47-.24.16.26-.83,2,.88-.1.47.71-.14.16-.29.15-.43.29s-.12.33.05.26c-.07.08,0,.18-.07.25-.36-.36-.13.7-.45.8-.16-.14-.28.33-.44.31s-.19.18-.28.14,0-.15,0-.32c.13-.12-.05-.08,0-.21.05-.35-.07,0-.16.06-.27.52.26.51-.33,1-.14.16-.14.51-.28.61s0,.25-.13.29-.11.27-.21.21c-.19.1.14.2-.33.31-.14.4.25,0,.28.32.17,1.13-1,.19-.69,1.9,0,.23.25-.14.27.08.06.06.15-.16.23-.21.38-.13.24-.84.52-1.07,0,0,.17-.19.14-.29,0-.35.36-.17.54-.65.14.26.75.19.56.82,0,.18.2-.24.2-.31,0-.26,0-.14.11-.26-.15-.18-.39-.12-.5-.39-.25-.65.47.1.58,0,0,.29.06.52.23.48-.14.3.09.41.21-.05,0-.1,0-.13-.07-.1s0-.17-.07-.2c.12,0,.25-.44.36-.26s0,.57.23.56.2-.31.31-.17.07.05.13,0c.39-.56.13.32.12.68,0,1,.66,1.72.92,2.4.34-.27,1.85-2.19,1.32-2.41-.21.12-.13-.6-.32,0-.15.25-.39.44-.32,0-.06,0-.11.2-.14.12,0-.27-.19-.24-.18-.5s.29.14.47.1a1.84,1.84,0,0,0,1.25-.44c.06,0,.08.07.12.13s.11,0,.13.09.22.55.35,0a6.83,6.83,0,0,0,.37,1.7c.25.58.37-.95.42-1.19.32-.49.93-2.12,1-1.31.37.31-.08.7.43.41.13,0,0,.31.08.36s-.07.07.06.09-.12.12,0,.15-.09.43,0,.56c.24,0,.14.54.33.67-.21.15-.28-.3-.5-.18s.39.57.39.87.44.17.47.45.34-.15.44-.08.74-.22.58-.31c-.21.09-.27-.17-.51.07s-.55.19-.41-.44c-.2,0-.32-.07-.38-.38,0,0,.18.06.16-.08-.08-.67-.59-.58-.41-1.42.19-.17.36.14.47.34a1.74,1.74,0,0,0,.45-.81c0-.49-.24-.49-.36-.75,0-.22.28-.7.37-.55s.07.05.1,0c.3-.56.78-.67.86-1.38.11-.28.33-.62.11-.67.21-.22,0-.11,0-.22.28-.11-.19-.28-.09-.55s.42-.51.1-.46c-.05.06-.13.35-.15.15-.37,0,.09-.42.26-.73,0,.37.11.1.24.07s-.13.55.22.21c-.07.47,0,.77.29.22.1-.36-.3-.41-.11-.7.29-.59.14-.66.57-.92a3.87,3.87,0,0,0,.59-2.25c0-.25-.42.4-.48-.07.75-1.43.7-1.45,1.71-1.85.18-.22.41-1.15.68-.91.1.35.26-.52.42-.51-.1.87-1.31,2-.71,2.82a5.8,5.8,0,0,1,.43-1c.18-.65-.06-.45,0-.75.18-.69.63-.6.94-1s.84-.7.6-1c-.1-.07-.26-.13,0-.19s.21-.66.34-.5.19-.1.26,0,.27.27.32-.12C200.72,61.46,201,61.49,200.94,61.3ZM186.89,74.39c-.24.42-.5.22-.76.39-.36.48-.74.48-.42-.26.11-.35.21-.56.43-.48,0,0-.1.13,0,.16s.06.09.21-.07c-.15-.26.19-.43.33-.67C186.38,74.44,186.77,73.87,186.89,74.39Zm1.24-.55c-.41.21.16.4-.11.79-.55.26-.34-.08-.4-.55a.59.59,0,0,1-.06-.83c.31-.6.68-.48.21.16C187.76,73.69,188.25,73.7,188.13,73.84Zm1.93-6.75c-.27,0-.05-.24,0-.49C190,66.86,190.28,66.94,190.06,67.09Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.06,67.36c0,.28.15.19.25.34-.1.27.14,0,.17.19s.22-.76.41-.79c.13.19.18.38.39,0-.8-.2.42-.51.2-1-.22.08-.41.31-.59.27s-.2.27-.32.38c-.19-.12,0,.41-.15.26-.08,0,.07-.11,0-.13s0,.07,0,0,0,.13-.06.14C184.38,66.78,183.84,67.27,184.06,67.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.47,65a3.86,3.86,0,0,0-1.4,2s-.06.1-.07.19-.26.29-.07.33a.4.4,0,0,0,.45,0C187.87,66.44,189.86,65.05,189.47,65Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.4,74s-.05.35,0,.31,0,.2.11.11.11,0,.12.1-.16.15-.12.29c-.17.46.15,0,0,.41.06.24.7-.5.65-.75-.07-.06-.19,0-.19-.16s-.14-.09-.13-.27c-.15,0-.14,0-.06-.25s-.11-.06-.14-.25c-.05.11-.16,0-.17.15S182.33,74,182.4,74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.32,72c-.13-.22-.35.29-.52.25s0,.29-.09.19c-.21-.33-.19.42,0,.43S182.65,72.11,182.32,72Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.11,75.36c.26-.25.4-.53.21-.81,0,.09-.35.23-.28.38S181.83,75.45,182.11,75.36Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.3,76.45c-.07,0,0,.21-.07.28S184.46,76.46,184.3,76.45Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.92,76c0-.55-.2.16-.15.4C183.8,76.8,184,76.12,183.92,76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.23,76.64s-.16.31-.08.28S183.48,76.49,183.23,76.64Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.48,41.05,162.89,66.79v47.68l44.59-25.74ZM204,86.73l-37.66,21.74V68.79L204,47.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.02 86.73 202.19 85.63 202.19 48.13 204.02 47.05 204.02 86.73",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.48 41.05 205.62 39.98 161.03 65.73 162.89 66.8 207.48 41.05",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.03 65.73 162.89 66.8 162.89 114.47 161.03 113.4 161.03 65.73",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--picture--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--frame--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "164.52 165.92 166.36 167.02 204.02 145.27 202.19 144.18 164.52 165.92",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.19 144.18 166.36 164.86 166.36 127.34 202.19 106.67 202.19 144.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.48,99.6l-44.59,25.74V173l44.59-25.75ZM204,145.27,166.36,167V127.34L204,105.59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.02 145.27 202.19 144.18 202.19 106.67 204.02 105.59 204.02 145.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.48 99.6 205.62 98.53 161.03 124.27 162.89 125.34 207.48 99.6",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.03 124.27 162.89 125.34 162.89 173.02 161.03 171.95 161.03 124.27",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Land--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "200.79 143.06 167.75 162.13 167.75 152.59 176.01 133.52 181.16 138.29 179.31 146.28 190.71 121.89 200.79 133.52 200.79 143.06",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.85,124.31a5.42,5.42,0,0,0-2.45,4.23c0,1.56,1.1,2.19,2.45,1.42a5.41,5.41,0,0,0,2.44-4.24C183.29,124.17,182.2,123.53,180.85,124.31Z",
    style: {
      fill: "#f0f0f0"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "36.24 252.05 39.48 252.27 141.58 193.27 139.97 192.1 36.24 252.05",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.97 192.1 39.48 250.18 39.48 107.46 139.97 49.38 139.97 192.1",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.82,42.86,36.24,105.59V257.87l108.58-62.73Zm-3.24,150.41-102.1,59V107.46l102.1-59Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.58 193.27 139.97 192.1 139.97 49.38 141.58 48.47 141.58 193.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.82 42.86 141.03 40.7 32.46 103.43 36.24 105.59 144.82 42.86",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.46 103.43 36.24 105.59 36.24 257.87 32.46 255.71 32.46 103.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.48 178.65 139.96 120.54 141.58 121.51 39.48 180.5 39.48 178.65",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.58 121.51 141.58 125.13 39.48 184.12 39.48 180.5 141.58 121.51",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blinds--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.48,152.4v4.32l101.34-58.6L140,94.34Zm0-6v4.31L140.82,92.09,140,88.3Zm0,12.07v4.31l101.34-58.59-.86-3.79Zm0,6v4.32l101.34-58.6L140,106.4ZM140,52.1,39.48,110.16v4.32l101.34-58.6ZM39.48,122.23v4.32L140.82,68,140,64.16Zm0,18.11v4.31L140.82,86.06,140,82.27Zm0-12.07v4.31L140.82,74,140,70.2Zm0-12.07v4.31L140.82,61.92,140,58.13Zm0,18.1v4.32L140.82,80,140,76.23Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,52.09,39.48,110.16v1.74L140.3,53.6ZM39.48,116.2v1.73L140.3,59.63l-.34-1.5Zm0,6V124L140.3,65.67,140,64.16Zm0,6V130L140.3,71.7,140,70.2Zm0,6V136L140.3,77.74,140,76.23Zm0,6v1.73L140.3,83.77l-.34-1.5Zm0,6v1.73L140.3,89.81,140,88.3Zm0,6v1.74L140.3,95.84l-.34-1.5Zm0,6v1.73l100.82-58.3-.34-1.5Zm0,6v1.74l100.82-58.3L140,106.4Z",
    style: {
      opacity: 0.2
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blackboard--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "263.46 182.88 458.85 295.63 458.85 293.76 263.46 181.01 263.46 182.88",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.48 177.54 263.46 181.01 458.85 293.76 464.88 290.29 269.48 177.54",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464.88 290.29 458.85 293.76 458.85 295.63 464.88 292.16 464.88 290.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.48 177.54 464.88 290.29 464.88 138.94 269.48 26.19 269.48 177.54",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.56 280.13 459.56 142.96 274.8 36.35 274.8 173.52 459.56 280.13",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.56 276.21 459.56 280.12 274.8 173.52 274.8 36.34 278.22 38.32 278.22 171.56 459.56 276.21",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "469.51 136.27 464.88 138.94 464.88 290.29 469.51 287.61 469.51 136.27",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.48 26.19 274.11 23.52 469.51 136.27 464.88 138.94 269.48 26.19",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.06,176.3c.78-.45-8.84-15.8-9.52-16.93-2.14-3.59-9-3.47-9.73,1.27A44.37,44.37,0,0,0,423,174c-5.47-12.68-9.89-26-17.1-37.74-2.52-4.13-10.62-2.86-9.92,2.69,1.69,13.52,5.29,26.51,9.36,39.37-7.69-20.64-12.94-42.4-17-63.16-1.16-5.88-10.72-4.56-10.46,1.42a255,255,0,0,0,4.34,37.26c-1.84-4.6-3.61-9.23-5.37-13.88-2.39-6.31-11.91-3.95-10.27,2.83.62,2.58,1.25,5.15,1.87,7.73q-3.78-8.85-7.34-17.79c-2-5-11.33-5.06-10.46,1.42.06.47.15.94.22,1.41h0l0,.1c.34,2.32.72,4.62,1.16,6.9-2.88-7.11-5.56-14.3-8.11-21.53-2.93-8.31-4.66-18.29-9.59-25.64a5.4,5.4,0,0,0-9.2,0c-4.3,6.79-1.73,14.57-.11,22a302.69,302.69,0,0,0,9,31.94c1.58,4.69,3.26,9.34,5,14-2.79-4.46-5.47-9-8-13.61-10.18-18.59-14.8-39.07-23.93-58-2.31-4.8-10.11-2.42-9.92,2.69.56,15.56,4.59,30.23,10.39,44.63,2,4.93,4.13,9.8,6.29,14.66q-9.81-14.16-18.7-29c-2.18-3.64-8.9-3.43-9.73,1.27a58.3,58.3,0,0,0,1.2,26.75c1.87,6.59,12.15,3.79,10.27-2.83-.36-1.28-.65-2.54-.92-3.79a536.87,536.87,0,0,0,32.19,44.26c2.86,3.54,9.4.65,9.09-3.77a47.06,47.06,0,0,0-1.54-8.8c7,10.56,14.57,20.82,22.09,31,4.1,5.58,11.91.93,9.19-5.37-4.38-10.17-8.72-20.35-12.85-30.62a256,256,0,0,0,22.46,36.69c4.05,5.49,12.16.9,9.19-5.37q-2.4-5.1-4.78-10.22a5.44,5.44,0,0,0,7.2-2.73c1.83,3.16,3.74,6.29,5.81,9.33a5.2,5.2,0,0,0,9-.09A181.76,181.76,0,0,0,421.42,232c3.53,4.77,11,2.08,9.74-4.1a299.07,299.07,0,0,0-9.56-33.36,91.59,91.59,0,0,0,7.27,10.88c3,3.82,9,.45,9.09-3.76.07-6-1.42-12-2.83-17.89,3.37,3.15,7.39,4.52,12.31,1.74C453.41,182.12,448,172.92,442.06,176.3Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.2,261.62a3.85,3.85,0,0,1,1.75-3,1.2,1.2,0,0,1,1.23-.12h0L434,269.88l-2.47,4.29-19.77-11.42h0A1.21,1.21,0,0,1,411.2,261.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.72,270a3.84,3.84,0,0,0-1.75,3c0,1.11.78,1.57,1.75,1a3.87,3.87,0,0,0,1.75-3C434.47,269.9,433.69,269.45,432.72,270Z",
    style: {
      fill: "#e6e6e6"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-3"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-3",
    cx: 349.25,
    cy: 423.42,
    rx: 69.77,
    ry: 40.28,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M174.77,442.68,87,392c-2-1.15-2-3,0-4.18l67.41-38.91a8,8,0,0,1,7.23,0l87.75,50.67c2,1.15,2,3,0,4.17L182,442.68A8,8,0,0,1,174.77,442.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-3",
    points: "193.05 466.54 120.08 424.46 220.99 366.18 293.95 408.26 193.05 466.54",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M112.34,416.4,91.85,428.19a12.33,12.33,0,0,1-11.16,0L41.88,405.77a3.4,3.4,0,0,1,0-6.44l20.49-11.79a12.33,12.33,0,0,1,11.16,0L112.34,410a3.89,3.89,0,0,1,2.31,3.21C114.66,414.34,113.89,415.51,112.34,416.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M451.25,384.91c9.14,5.33,9.14,14,0,19.32s-23.95,5.33-33.09,0-9.13-14,0-19.32S442.11,379.58,451.25,384.91Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.67,396.06c-7.51-7.75-11.92-32.91-4.6-39.06h37.27c7.32,6.15,2.92,31.3-4.59,39.05l-.2.21-.26.26c-.21.21-.44.41-.68.61l-.18.14c-.18.15-.37.29-.57.43a9.42,9.42,0,0,1-1,.63c-6.18,3.61-16.19,3.61-22.37,0h0a10.76,10.76,0,0,1-1-.63l-.52-.4-.22-.18c-.24-.19-.45-.39-.66-.59l-.3-.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.1,354.53c8.51,5,8.51,13,0,18s-22.29,5-30.79,0-8.5-13,0-18S441.6,349.56,450.1,354.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446,356.92c6.25,3.64,6.25,9.55,0,13.2s-16.36,3.65-22.61,0-6.24-9.56,0-13.2S439.77,353.27,446,356.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.4,363.18c6.25-3.64,16.37-3.64,22.61,0a10.47,10.47,0,0,1,3.74,3.47,10.3,10.3,0,0,1-3.74,3.47c-6.24,3.65-16.36,3.65-22.61,0a10.38,10.38,0,0,1-3.74-3.47A10.56,10.56,0,0,1,423.4,363.18Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M429.61,316.89c-2.52,3.18-10.08,4.58-13.84-3.2-3.54-7.31-7.27-14.2-8.39-16.89a2.85,2.85,0,0,1,1.54-3.82s-.1-4.15,7.12-1.88,12.49,6.14,16.07,12.79S434.23,315.61,429.61,316.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.45,327.27a36.92,36.92,0,0,0-.93-4.14,57.11,57.11,0,0,0-2.94-7.89,59.39,59.39,0,0,0-9.26-14.38,51.48,51.48,0,0,0-6.94-6.75c-.08-.06-.12.1-.07.15a63.57,63.57,0,0,1,11.05,13.05,64.73,64.73,0,0,1,7,15.22c.46,1.5.91,3,1.3,4.53s.69,3.1,1.07,4.65c0,.16.29.23.29,0A30.53,30.53,0,0,0,433.45,327.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.45,327.27a36.92,36.92,0,0,0-.93-4.14,57.11,57.11,0,0,0-2.94-7.89,59.39,59.39,0,0,0-9.26-14.38,51.48,51.48,0,0,0-6.94-6.75c-.08-.06-.12.1-.07.15a63.57,63.57,0,0,1,11.05,13.05,64.73,64.73,0,0,1,7,15.22c.46,1.5.91,3,1.3,4.53s.69,3.1,1.07,4.65c0,.16.29.23.29,0A30.53,30.53,0,0,0,433.45,327.27Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.8,311.32c-6.56,2-11.43-3.09-9.74-11.12s10.12-16.94,13.3-14.55c2-2,6.37-1.27,8.43,5.25S450,314.16,437.8,311.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.65,290.54A88.11,88.11,0,0,0,437.29,305a137.87,137.87,0,0,0-2.53,15.1,236,236,0,0,0-1.32,29.6q0,4.09.11,8.19c.05,2.81,0,5.65.25,8.45.09,1.07,1.62.79,1.64-.19.09-4.92-.17-9.86-.22-14.78s0-9.72.09-14.58A204.62,204.62,0,0,1,438,307.19c.47-2.72,1-5.44,1.62-8.12s1.49-5.62,2.23-8.43C441.84,290.53,441.71,290.39,441.65,290.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.65,290.54A88.11,88.11,0,0,0,437.29,305a137.87,137.87,0,0,0-2.53,15.1,236,236,0,0,0-1.32,29.6q0,4.09.11,8.19c.05,2.81,0,5.65.25,8.45.09,1.07,1.62.79,1.64-.19.09-4.92-.17-9.86-.22-14.78s0-9.72.09-14.58A204.62,204.62,0,0,1,438,307.19c.47-2.72,1-5.44,1.62-8.12s1.49-5.62,2.23-8.43C441.84,290.53,441.71,290.39,441.65,290.54Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.6,333.28c-1.89,3.9-8.29,5.38-14.08,1s-14.17-24.66-7.83-25c.49-3.15,18.86-1,24.77,12.08C432.77,330.88,425.6,333.28,425.6,333.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.29,341.82a29.87,29.87,0,0,0-1.88-3.59,80.8,80.8,0,0,0-4.56-6.91,82.75,82.75,0,0,0-11.39-12.42,74.09,74.09,0,0,0-7.29-5.94c-.07,0-.08.11,0,.15,2.07,1.74,4.15,3.44,6.1,5.32s3.92,4,5.74,6.16a104.09,104.09,0,0,1,9.5,13.08c.8,1.31,1.53,2.66,2.34,4s1.79,2.63,2.58,4c.11.2.41.2.3-.07C434.22,344.33,433.82,343.06,433.29,341.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.29,341.82a29.87,29.87,0,0,0-1.88-3.59,80.8,80.8,0,0,0-4.56-6.91,82.75,82.75,0,0,0-11.39-12.42,74.09,74.09,0,0,0-7.29-5.94c-.07,0-.08.11,0,.15,2.07,1.74,4.15,3.44,6.1,5.32s3.92,4,5.74,6.16a104.09,104.09,0,0,1,9.5,13.08c.8,1.31,1.53,2.66,2.34,4s1.79,2.63,2.58,4c.11.2.41.2.3-.07C434.22,344.33,433.82,343.06,433.29,341.82Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.61,331.64c-3.74-.85-3.93-5.36.75-10.88s16.49-7.93,17.05-5.61c2.63,0,2.63,8.22-3.18,15.77S438,336.71,437.61,331.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,323.61a29.46,29.46,0,0,0-10.85,14c-.12.32.43.79.56.44A34.49,34.49,0,0,1,445,323.68S445,323.57,445,323.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,323.61a29.46,29.46,0,0,0-10.85,14c-.12.32.43.79.56.44A34.49,34.49,0,0,1,445,323.68S445,323.57,445,323.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.9,359.06c-5.2,2.1-3,8.28,2.1,13a23.15,23.15,0,0,0,15.8,5.69c3.48-.25,4.37-.73,4.37-.73a39.63,39.63,0,0,0,0-8.59,16.62,16.62,0,0,0-12.24-13.18C443.84,353,441.9,356,441.9,359.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.27,368.19a42,42,0,0,0-7.95-7.35c-3-1.95-6.9-3.61-10.44-2.4-1.38.47-3.51,1.84-3.26,3.54,0,.17.33.59.53.36a14.44,14.44,0,0,1,1.87-2.18,5.52,5.52,0,0,1,2.79-1.06,12.85,12.85,0,0,1,7.28,1.66c3.51,1.86,6.34,4.74,9.14,7.51C456.26,368.3,456.29,368.22,456.27,368.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456.27,368.19a42,42,0,0,0-7.95-7.35c-3-1.95-6.9-3.61-10.44-2.4-1.38.47-3.51,1.84-3.26,3.54,0,.17.33.59.53.36a14.44,14.44,0,0,1,1.87-2.18,5.52,5.52,0,0,1,2.79-1.06,12.85,12.85,0,0,1,7.28,1.66c3.51,1.86,6.34,4.74,9.14,7.51C456.26,368.3,456.29,368.22,456.27,368.19Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.16,338.76c0-2.2-3.94-6.72-13.67-5.94-4.44.35-8.51,1.55-11.78,4.69a6.76,6.76,0,0,0-2.15,3.91,2.9,2.9,0,0,0,.24,1.72,3,3,0,0,0,.84,1c2.32,1.87,5.35,1.38,8.09,2.08,4.25,1.08,13.19,4.95,18.34,2.37S425.25,340.38,422.16,338.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.78,344.83c-5.56-7.58-16.4-8.22-24.88-6.62a33.71,33.71,0,0,0-8.08,2.59s0,.11,0,.09a44.63,44.63,0,0,1,13.8-2.67,29.24,29.24,0,0,1,13.53,2.56,17.29,17.29,0,0,1,5.44,4.24C430.77,345.2,430.89,345,430.78,344.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.78,344.83c-5.56-7.58-16.4-8.22-24.88-6.62a33.71,33.71,0,0,0-8.08,2.59s0,.11,0,.09a44.63,44.63,0,0,1,13.8-2.67,29.24,29.24,0,0,1,13.53,2.56,17.29,17.29,0,0,1,5.44,4.24C430.77,345.2,430.89,345,430.78,344.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.93,320.05c-.14,3.73,5.1,5.89,10.17,2.67s10.39-6.35,15.08-7.57,6.93-5,5.44-6.9-3.84-6.53-16.19-5-16.73,7.09-18.42,11S445.07,321.13,446.93,320.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,308.24a13.42,13.42,0,0,0-5.3.55,26,26,0,0,0-4.53,1.63,25.13,25.13,0,0,0-7.73,5.59,20.62,20.62,0,0,0-1.74,2.1,8.88,8.88,0,0,0-1.32,2.16c-.08.24.28.64.49.39.61-.7,1.07-1.56,1.65-2.31a24.94,24.94,0,0,1,2-2.27,25.37,25.37,0,0,1,4.76-3.75,29.61,29.61,0,0,1,5.28-2.57c1-.36,2-.66,3.07-.92a10.62,10.62,0,0,1,3.36-.47C467.06,308.38,467.09,308.25,467,308.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467,308.24a13.42,13.42,0,0,0-5.3.55,26,26,0,0,0-4.53,1.63,25.13,25.13,0,0,0-7.73,5.59,20.62,20.62,0,0,0-1.74,2.1,8.88,8.88,0,0,0-1.32,2.16c-.08.24.28.64.49.39.61-.7,1.07-1.56,1.65-2.31a24.94,24.94,0,0,1,2-2.27,25.37,25.37,0,0,1,4.76-3.75,29.61,29.61,0,0,1,5.28-2.57c1-.36,2-.66,3.07-.92a10.62,10.62,0,0,1,3.36-.47C467.06,308.38,467.09,308.25,467,308.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.06,340.15c-1.73-1.73-6.43-1.33-8.65,3.78s2.44,10.71,3,12.29c2.14-1.24,3.81-.5,7.59-1.24a9.43,9.43,0,0,0,7.24-9.41C447,340.89,445,337.8,438.06,340.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,339.63a7.18,7.18,0,0,0-2.3,2.38,12.72,12.72,0,0,0-1.48,2.86,12.2,12.2,0,0,0-.65,6.52c0,.08.08,0,.08-.05a13.31,13.31,0,0,1,1.09-6.44,13,13,0,0,1,1.56-2.58,13.27,13.27,0,0,1,1-1.21,6.24,6.24,0,0,0,1-1C438.46,339.93,438.26,339.5,438,339.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,339.63a7.18,7.18,0,0,0-2.3,2.38,12.72,12.72,0,0,0-1.48,2.86,12.2,12.2,0,0,0-.65,6.52c0,.08.08,0,.08-.05a13.31,13.31,0,0,1,1.09-6.44,13,13,0,0,1,1.56-2.58,13.27,13.27,0,0,1,1-1.21,6.24,6.24,0,0,0,1-1C438.46,339.93,438.26,339.5,438,339.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.92,353.89c-1-3.69-5.63-5.75-11.74-6.21A16,16,0,0,0,404,355.47c-3.2,5.47-4.52,9.82-2.58,10.53s10.14,1.85,15.44,2.32,11.91-.48,16.23-4.51S436,354.74,430.92,353.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.15,353.4a15.91,15.91,0,0,0-6.59-.3,28.89,28.89,0,0,0-6.23,1.43,40.12,40.12,0,0,0-6.17,2.77c-1,.57-2.05,1.17-3,1.8a22.47,22.47,0,0,0-2.73,1.89s0,.16,0,.13c1-.45,1.94-1.08,2.9-1.62s2.07-1.15,3.13-1.69a45.5,45.5,0,0,1,6.11-2.59,29.37,29.37,0,0,1,6.48-1.39,39.85,39.85,0,0,1,6.18.16C431.65,354,431.41,353.48,431.15,353.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.15,353.4a15.91,15.91,0,0,0-6.59-.3,28.89,28.89,0,0,0-6.23,1.43,40.12,40.12,0,0,0-6.17,2.77c-1,.57-2.05,1.17-3,1.8a22.47,22.47,0,0,0-2.73,1.89s0,.16,0,.13c1-.45,1.94-1.08,2.9-1.62s2.07-1.15,3.13-1.69a45.5,45.5,0,0,1,6.11-2.59,29.37,29.37,0,0,1,6.48-1.39,39.85,39.85,0,0,1,6.18.16C431.65,354,431.41,353.48,431.15,353.4Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442,344.84c-4.19-3.33-2.8-11.33,11.89-11.76s25.17,3.41,24.71,8.13c2.36,2.36,1.16,9-10.73,11.05S439,353.3,442,344.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.72,341.26a63.3,63.3,0,0,0-13.12-.76,50.29,50.29,0,0,0-12.11,1.39,17.25,17.25,0,0,0-3,1.1,13.18,13.18,0,0,0-1.28.69c-.34.2-.71.38-.83.77a.4.4,0,0,0,.44.46,15.33,15.33,0,0,0,2.57-1.27,18.76,18.76,0,0,1,2.54-.92,31.52,31.52,0,0,1,5.1-1,90.08,90.08,0,0,1,12.4-.68c2.41,0,4.81.21,7.22.4C471.76,341.44,471.79,341.28,471.72,341.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.72,341.26a63.3,63.3,0,0,0-13.12-.76,50.29,50.29,0,0,0-12.11,1.39,17.25,17.25,0,0,0-3,1.1,13.18,13.18,0,0,0-1.28.69c-.34.2-.71.38-.83.77a.4.4,0,0,0,.44.46,15.33,15.33,0,0,0,2.57-1.27,18.76,18.76,0,0,1,2.54-.92,31.52,31.52,0,0,1,5.1-1,90.08,90.08,0,0,1,12.4-.68c2.41,0,4.81.21,7.22.4C471.76,341.44,471.79,341.28,471.72,341.26Z",
    style: {
      opacity: 0.1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.37,145.48c-12.66,1.94-16.29,3.63-24.61,17.1-7.12,11.52-19.85,34-19.85,34l17,12.31c6.19-11.17,13.29-19.15,23.37-35.52Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.2,399.09c-.52-15.15.2-24.46-1.05-46.67h0c-.11-5.69-.32-11.78-.72-17.2-1.35-18.22-4.3-24.45-4.57-28,0,0-.51-28.35-1.76-68.23-.58-18.75-6.29-24.43-10.84-34.39H320.9c-6,24.57-6.58,78.14-6.4,103.46.09,12.91,5.56,78.58,5.67,80.17.39,5.63-.13,7.86-2.44,10.22-4.86,5-11.89,9.69-18,14,.88,2.22,8.19,2.13,11.81.45a93.11,93.11,0,0,0,13.5-8.2c5-3.53,12.78-6.58,12.86-11.94a4.45,4.45,0,0,1,.17-1c.09-3.13,6.36-45.72,7-56.44.55-9.21-.62-24.85-.62-24.85l6.23-39s3.85,23.07,7.74,38.83c3.17,12.82,8.39,34.71,12,50.49h0c3.42,18.19,8.45,31.13,9.32,40.23.26,2.17,2.84,23.51,3.91,28.39s12.24,5,13-3.39C397.06,420.48,395.29,401.77,395.2,399.09Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.41,418.17c-.31,0-.81,3.24.85,4.64,1.92,1.61,7.58,4.28,15.11,3.43s11.63-3,14.67-5.39,7.29-5.71,10.7-6.39c3.16-.63,8-2.18,9-3.1s.92-5.06.92-5.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.25,390.34s.57,0,.75,1c.22,1.14.44,4.46.91,6.34.66,2.61,1.07,7.94.63,10.06s-7,3.75-10.31,4.92A42.07,42.07,0,0,0,319.5,419c-3.57,2.74-11,5.45-15.94,5.47-7.48,0-12.3-2-13.77-4.54-1.81-3.19-.34-5,8.3-8.72,1.63-.7,7.39-3.87,9.35-5a44.6,44.6,0,0,0,5.9-4.09A34,34,0,0,0,316,399.6,11.49,11.49,0,0,0,318.2,397c.1-.21.17-.46.26-.69a12.74,12.74,0,0,0,.58-1.91c.14-.68.24-1.67.93-2.08A6,6,0,0,1,323,392a24.44,24.44,0,0,1,3.31.48c1.27.28,2.73.41,3.47,1.55a5.77,5.77,0,0,1,.67,3c0,.48,0,1,0,1.44,0,.21-.09.57.21.49s.61-.79.72-1c.25-.53.41-1.11.67-1.63a8.78,8.78,0,0,1,1.09-1.72,6.33,6.33,0,0,1,2.58-1.74c.95-.4,2.34-.94,2.34-.94S338.2,390.74,338.25,390.34Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.69,411.77c10.83.82,14.17,7.23,14.58,11.18a26.65,26.65,0,0,1-7.71,1.47c-7.48,0-12.61-2-14.08-4.54C287.77,416.87,289,414.47,296.69,411.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.93,412a.53.53,0,0,0,.34-.11.49.49,0,0,0,.08-.71,13.06,13.06,0,0,0-9.75-3.78.52.52,0,0,0-.48.55.53.53,0,0,0,.58.46,12,12,0,0,1,8.82,3.4A.53.53,0,0,0,312.93,412Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.63,409.5a.59.59,0,0,0,.33-.11.48.48,0,0,0,.08-.71,13,13,0,0,0-9.75-3.78.51.51,0,0,0-.47.55.5.5,0,0,0,.57.45,12.07,12.07,0,0,1,8.83,3.41A.53.53,0,0,0,317.63,409.5Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,406.58a.48.48,0,0,0,.34-.11.49.49,0,0,0,.08-.71,13.09,13.09,0,0,0-9.75-3.78.52.52,0,0,0-.48.55.53.53,0,0,0,.58.46,12.06,12.06,0,0,1,8.82,3.41A.55.55,0,0,0,322,406.58Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.25,403.67a.52.52,0,0,0,.33-.11.48.48,0,0,0,.09-.7c-2-2.52-6.71-4.22-10.65-3.85a.52.52,0,0,0-.48.55.53.53,0,0,0,.58.46c3.55-.33,7.9,1.22,9.72,3.45A.51.51,0,0,0,326.25,403.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.12,433.27c.3,4.87,1.09,8.1,2.91,11s5.23,3.76,8.69,2.92,7.9-3.07,8.89-7.27,1.57-7.08.79-11.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.17,398c1.42.1,1.36,6.64,2.18,13.19.88,7,3.08,9.92,3.87,15.67.9,6.58-.24,9.51-2.66,13.49s-11,7.87-15.18,2.18c-3.44-4.64-3.58-9.79-3.27-16.35a140.37,140.37,0,0,0-.46-16.64c-.28-4.92-1.42-9.88-.18-10.43.1.72.19,1.64.29,2.35a11.16,11.16,0,0,0,.46,2.63c.15.36.46.75.59.15a3.57,3.57,0,0,0,0-1.22c-.21-1.82.75-2,1.27-2.1a64.42,64.42,0,0,1,6.62-.9c1.09-.07,4.85-.23,5.34.37a3.89,3.89,0,0,1,.48,1.9c.12,1,.36,1.71.39,1.4C395,403,395.19,398.43,395.17,398Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.62,430.68a15.86,15.86,0,0,1-2.67,10c-2.42,4-11.66,7.89-15.88,2.19-2.1-2.83-2.66-6.18-2.95-9.59C382.65,428.88,397.63,427,401.62,430.68Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.24,426.12a.55.55,0,0,0,.17-.05c.06,0,6.66-2.63,13.09-1.21a.55.55,0,0,0,.64-.38.51.51,0,0,0-.4-.6c-6.8-1.5-13.53,1.17-13.79,1.28a.5.5,0,0,0-.24.68A.53.53,0,0,0,383.24,426.12Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.18,420a.52.52,0,0,0,.45-.34.51.51,0,0,0-.33-.64c-6.4-2.06-13.5,1-13.77,1.17a.49.49,0,0,0-.22.68.54.54,0,0,0,.71.21c.06,0,7-3,12.94-1.1A.55.55,0,0,0,396.18,420Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,415.34a.52.52,0,0,0,.44-.33.49.49,0,0,0-.32-.64c-7-2.41-13.77,1-14,1.13a.49.49,0,0,0-.18.69.54.54,0,0,0,.72.17c.06,0,6.57-3.28,13.12-1A.65.65,0,0,0,396,415.34Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.61,410.79a.5.5,0,0,0,.44-.32.5.5,0,0,0-.31-.65c-6.6-2.35-13.85,1.12-14.12,1.27a.49.49,0,0,0-.2.69.55.55,0,0,0,.73.19c.06,0,7.09-3.39,13.22-1.2A.65.65,0,0,0,395.61,410.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.67,199.94c8.79,17.4,10.22,25.12,10.87,58.28s.54,42.46.68,46.45,2.57,11.15,4.72,30.85.3,43.17.3,43.17-2.17,3.16-10.08,3.84c-7.29.62-10.9-2-10.9-2s-10-38.35-12.76-50.22-10.8-50.87-10.8-50.87l-4.76,31.64s2.22,10.87,0,28.14S341.19,374,341.19,374s-4.08,2.43-12.59,2a23.34,23.34,0,0,1-9.82-2.45s-6.2-51.39-6.2-71,1.49-68.36,7.42-99.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.83,233.26c3.09,8.08,14.36,13.74,19.32,14.87L348,279l-2,32.06,4.76-31.64-6.5-37.65S330.46,240.86,322.83,233.26Zm47-3.95c.81,3.18,1.55,6.38,2.33,9.57s1.54,6.4,2.37,9.62a60.85,60.85,0,0,0-.69-9.91,93.32,93.32,0,0,0-1.88-9.76,84.52,84.52,0,0,0-3-9.52,45.08,45.08,0,0,0-4.46-9c1,3.16,2,6.31,2.84,9.47S369,226.12,369.81,229.31Zm5.84-6.12c1.12,1.92,2.18,3.86,3.25,5.8l3.16,5.93a25.5,25.5,0,0,0-1.59-6.58,43.09,43.09,0,0,0-2.9-6.15,48.68,48.68,0,0,0-3.82-5.65,36,36,0,0,0-4.7-5c1,2,2.15,4,3.27,5.91S374.57,221.26,375.65,223.19Zm-5.16,89.41c-2-10.14-3.39-20.4-4.79-30.66s-2.7-20.55-4.2-30.81c.66,10.34,1.44,20.68,2.51,31s2.37,20.63,4.33,30.86,4.19,20.32,6.43,30.47,4.55,20.25,7,30.34q-2.48-15.36-5.36-30.66C374.55,332.94,372.52,322.73,370.49,312.6Zm-49.44-34.46,1.78-27q-2.19,13.38-3.47,26.88c-.85,9-1.66,18-1.69,27.1.32,9.08,1,18.05,1.82,27.06s1.72,18,2.83,26.94q-.39-13.55-1.13-27.05l-.71-13.51c-.24-4.5-.53-9-.62-13.47s.2-9,.41-13.45S320.79,282.64,321.05,278.14Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M392.27,119.63c.91-1.68,1.05-4.95-.29-6.32a7.6,7.6,0,0,0-4.7-2.18c-3.74-.62-3.65-3.35-3.77-4.24-.47-3.43-1.68-5.34-3.68-6.5-5.36-3.11-18.73-2.12-17.42,6.75.2,1.32.8,2.73.21,3.92a4.26,4.26,0,0,1-1.15,1.28c-2.14,1.79-4.45,3.46-6.07,5.74s-2.44,5.37-1.25,7.9,3.8,3.87,4.5,6.41c1,3.48-2.23,7.27-.88,10.62,1.08,2.69,3.36,3.05,5.83,3.15,2.85.11,4.17,3.47,7.35,2.91a17.14,17.14,0,0,1,4.23.11,12.14,12.14,0,0,0,5.12-.59,6.52,6.52,0,0,0,3.76-3.39c.62-1.46.58-3.22,1.52-4.5.8-1.1,2.05-1.77,2.92-2.82a6,6,0,0,0,1.66-3.75c0-.44-.1-2.12-1.05-2.79a2.49,2.49,0,0,1,2,2,7.33,7.33,0,0,1-.22,3,6.3,6.3,0,0,0,1.64-9.36c-.72-.9-1.74-1.7-1.86-2.84C390.43,122.33,391.37,121.27,392.27,119.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.59,98.47c5.26,2.21,5.87,11.89.13,16.65S363.64,94.58,371.59,98.47Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M319.69,95.94c.29-6.53,7.54-7.54,9.49-7.51a9.21,9.21,0,0,0,7.15-3.89A9.28,9.28,0,0,1,345,81c5.31.83,4.33,3.12,8.86,4.15,4,.93,6.8-.64,10.69,2.39a10.14,10.14,0,0,1,3.5,8.21c2.83,1.38,7.39,10.82,3,22.13-2.26,5.82-5.37,8.74-9.12,13.74l-4.08.42c-1.68-3.32-5.08-2.33-8.34-2.8-2.11-.7-3.5-2.86-5.62-3.57s-4.49.21-6.75,0c-1.76-.13-3.61-1-5.36-.35-3.93,2.07-10.44-.87-10.45-5.64,0-1.44.66-2.91.24-4.3-.55-1.81-2.62-2.63-3.83-4.09a5,5,0,0,1-.3-5.94C320.05,101.93,319.53,99.66,319.69,95.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.34,144.92l2.1-.47c1.8-.41,1.44-1.33,1.43-3.12l-.11-2.79c-4.25.57-6.57,0-8.68-1.28-3.54-2.12-6.77-5.39-7.72-16.93-.39-4.65.76-7,.59-8-1-6.18-.63-7.34.5-10.7,2.1-5.38,8.49-7.9,11.86-2.67,7.49-7.13,17.28.3,17.88,9.94-.31,8,2.17,8.18,3.72,8.08,1.79-5.16,6.92-5.59,9.38-2.61,2.24,2.7,2.62,7.15-.74,11.57s-7.6,2.17-7.73,1.38c0,0,.45,10.74.58,12.88s1.62,2.92,4.36,3.53h0c2.79.63,2.8,1.34,2.8,1.34s-.18.29-.55.79c-.85,1.21-2.7,3.87-5.83,8.41-8.69,4.27-19,10-25,14.46a116.39,116.39,0,0,1-5.48-13.53A113.28,113.28,0,0,1,339.34,144.92Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.68,112.66a2.11,2.11,0,0,0,1.35,2.68,2.14,2.14,0,0,0,2.63-1.46,1.75,1.75,0,0,0-1.31-2.33A2,2,0,0,0,344.68,112.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.32,113.82a2.09,2.09,0,1,0,4.13-.59c-.17-1.18-1.2-1.59-2.33-1.43S330.16,112.64,330.32,113.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.07,106.5l4.53-1.58a2.3,2.3,0,0,0-3-1.52A2.51,2.51,0,0,0,329.07,106.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.9,106.69l-4.55-1.53a2.31,2.31,0,0,1,3-1.56A2.53,2.53,0,0,1,350.9,106.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.21,124.4a1.9,1.9,0,1,1-2.09-1.68A1.9,1.9,0,0,1,367.21,124.4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.45,124.59l-5.9,2.21a3.1,3.1,0,0,0,4,2A3.29,3.29,0,0,0,346.45,124.59Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.14,126a3.48,3.48,0,0,0-3.33,2.87,3,3,0,0,0,1.75-.11,3.22,3.22,0,0,0,2-2.72A3.42,3.42,0,0,0,346.14,126Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.76,138.54c7.62-1.16,14.86-3.64,16.5-8.42a7.87,7.87,0,0,1-4,6.75,27.76,27.76,0,0,1-12.38,3.92Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.44,119.55l-.17,0a6.28,6.28,0,0,1-1-12.51,6.27,6.27,0,0,1,1.18,12.49ZM330.2,108a5.33,5.33,0,1,0,5.88,4.87h0a5.33,5.33,0,0,0-5.74-4.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332.78 119.93 339.3 122.64 339.98 110.31 332.78 119.93",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.46,119.53h-.16A6.26,6.26,0,0,1,342,109.23a6.2,6.2,0,0,1,4.27-2.19,6.27,6.27,0,0,1,1.18,12.49ZM346.22,108a5.35,5.35,0,0,0-4.75,5.73,5.33,5.33,0,1,0,10.63-.86l.47,0-.47,0a5.32,5.32,0,0,0-5.74-4.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.55,113.77a1.84,1.84,0,0,0-1.7-1.34,1.94,1.94,0,0,0-1.85,1.33l-.87-.34a2.84,2.84,0,0,1,2.75-1.93,2.79,2.79,0,0,1,2.56,2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.34,114.51h-.11l-9.71-1.22a.47.47,0,0,1-.41-.53.46.46,0,0,1,.52-.4l9.72,1.21a.47.47,0,0,1,0,.94Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M341,144.53s-1.54,5.65.86,9.91c11.48-1.52,21.08-7,24.94-10.71l9.28,2.4s6.95,10.91,5.18,21.2-3.43,32.33-3.43,32.33c-10.65,16.09-55.87,9.92-57,2.68,0,0-1.33-9.07-2.39-16.48a23.14,23.14,0,0,1-3.93-11.48c-.4-7,2.41-12,9.37-19.38,7.15-7.57,10.52-9.52,10.52-9.52Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341,144.53s-1.54,5.65.86,9.91c11.48-1.52,21.08-7,24.94-10.71l9.28,2.4s6.95,10.91,5.18,21.2-3.43,32.33-3.43,32.33c-10.65,16.09-55.87,9.92-57,2.68,0,0-1.33-9.07-2.39-16.48a23.14,23.14,0,0,1-3.93-11.48c-.4-7,2.41-12,9.37-19.38,7.15-7.57,10.52-9.52,10.52-9.52Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.35,183.41A14.8,14.8,0,0,1,347,190.72a15.61,15.61,0,0,1-13-8.76s0,10.9,12.88,11.37S361.35,183.41,361.35,183.41Z",
    style: {
      fill: "#BA68C8",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.91,175.08s.2-1.84-2.16-3.72-5.45-3.44-6.31-7.93l-3.41,1.8,5.25,9.66Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.91,175.08s.2-1.84-2.16-3.72-5.45-3.44-6.31-7.93l-3.41,1.8,5.25,9.66Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.91,175.08s3.72-1.69,11.64.27,14.36,4.35,29.72,4.61l-4.07,2.14-39.74-3.86Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.91,175.08s3.72-1.69,11.64.27,14.36,4.35,29.72,4.61l-4.07,2.14-39.74-3.86Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.27 179.96 343.72 226.35 339.65 228.49 327.2 182.1 331.27 179.96",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.27 179.96 343.72 226.35 339.65 228.49 327.2 182.1 331.27 179.96",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331.27 179.96 343.72 226.35 339.65 228.49 327.2 182.1 331.27 179.96",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.35,165.89a7.94,7.94,0,0,0,1.54,2.65,23.49,23.49,0,0,0,2.2,2.15,16.06,16.06,0,0,1,2.16,2.12,5.32,5.32,0,0,1,.74,1.28,3,3,0,0,1,.24,1.37l.48.09a3.35,3.35,0,0,0-.32-1.63,5.79,5.79,0,0,0-.85-1.33,16.08,16.08,0,0,0-2.29-2.09,23.23,23.23,0,0,1-2.27-2A7.86,7.86,0,0,1,281.35,165.89Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M281.89,168.5a7.38,7.38,0,0,0,1.16,1.62c.44.5.89,1,1.32,1.49a11.09,11.09,0,0,1,1.14,1.6,4.17,4.17,0,0,1,.56,1.79l.49,0a4.54,4.54,0,0,0-.74-1.94,9.69,9.69,0,0,0-1.27-1.57c-.46-.48-.94-.94-1.41-1.41A7.4,7.4,0,0,1,281.89,168.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M315.91,179.7a58.62,58.62,0,0,1-6.45-1.21c-2.13-.51-4.24-1.13-6.35-1.71a29.86,29.86,0,0,0-6.5-1.1,23,23,0,0,0-3.32,0,10.57,10.57,0,0,0-1.66.25,4.11,4.11,0,0,0-1.59.71l.33.37a3.61,3.61,0,0,1,1.37-.64,10.54,10.54,0,0,1,1.59-.26,23.63,23.63,0,0,1,3.26-.07,30,30,0,0,1,6.45,1c2.13.54,4.25,1.12,6.39,1.59A59.61,59.61,0,0,0,315.91,179.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M305.39,179.09c-1.23-.21-2.44-.52-3.65-.8s-2.44-.55-3.67-.77a24.57,24.57,0,0,0-3.74-.39,10.27,10.27,0,0,0-3.76.54l.18.46a9.78,9.78,0,0,1,3.58-.63,23,23,0,0,1,3.7.27c1.23.17,2.46.4,3.68.64S304.15,178.92,305.39,179.09Z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "278.11 162.93 284.24 174.39 297.6 224.12 295.56 225.19 289.54 211.22 276.08 164 278.11 162.93",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.2 175.46 276.08 164 289.54 211.22 295.56 225.19 282.2 175.46",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.64 178.42 329.82 182.47 343.18 232.21 341.15 233.28 301.96 229.23 288.6 179.49 290.64 178.42",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.79 183.54 341.15 233.28 301.96 229.23 288.6 179.49 327.79 183.54",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.82 182.47 327.79 183.54 341.15 233.28 343.18 232.21 329.82 182.47",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.6,179.49l-6.4-4,13.36,49.73c.92,2.7,3.12,4,6.4,4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.6,179.49l-6.4-4,13.36,49.73c1,2.85,3.3,4,6.4,4Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.46,174.27c1.25-.67,3.68-.31,5.45.81s2.19,2.55.95,3.21l-2.26,1.2-6.4-4,2-1.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.24,174.39c.31,1.9,2.67,3.17,6.4,4l-2,1.07c-3.2-.49-5.29-1.88-6.4-4Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.89,146.13c9.68,3.09,14,6,15.6,17,1.77,12.26,2.84,21.87,3.35,42.22.12,4.81,1.57,10.71-9.19,13.25-13.8,3.26-34,5-39,5.47-3.22.27-10.32.89-12.83.59-7.84-.94-12-5.62-14.49-8.06-1.36-1.35-2.68-3-2.66-4.92a6.6,6.6,0,0,0,0-1.83,8.39,8.39,0,0,0-.88-1.61,3.23,3.23,0,0,1-.32-2,10.14,10.14,0,0,0,.36-1.79c0-1.24-1.16-2.13-1.67-3.26a1.1,1.1,0,0,1-.11-.53c0-.41.48-.65.88-.74a8.11,8.11,0,0,1,5.31,1.19c5,3,7.79,6.8,14.75,7,1.67,0,3.68-.62,3.24-2.23l-.85-3.18c4,.81,6.12,4.73,9.4,5.41,2.9.6,26.48-7.27,26.48-7.27l-2-24.2S366.33,153.78,375.89,146.13Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.91,191.47a27,27,0,0,0,2.59,5.05c.73,1.3.62,2.81-.24,3.18l2.34,8.23s-1.15.13-3.55-2.66-4-8-4.49-10.83-.78-7.87,1.61-9.07Z",
    style: {
      fill: "#ffbda7"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224.55,399.23l-9-68-7.43-.38,12.68,68.41h0a1,1,0,0,0,.5.66A2.93,2.93,0,0,0,224,400a.92.92,0,0,0,.59-.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.56,331.19l-7.43-.38L210.77,345a22.81,22.81,0,0,0,4.55-2.21,3.77,3.77,0,0,0,1.58-1.55Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.43,323.93H115L104.16,392.8h0a.91.91,0,0,0,.54.82,3,3,0,0,0,2.66,0,1,1,0,0,0,.52-.64h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115,323.93l-3.11,19.83a28.73,28.73,0,0,0,5.62,3.55l4.94-23.38Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.83,424.67l-6.89-69.32L160.5,355l10.59,69.69h0a1,1,0,0,0,.5.67,3,3,0,0,0,2.65.13.88.88,0,0,0,.58-.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.06,366.66l-1.12-11.31L160.5,355l1.85,12.18A13.06,13.06,0,0,0,169.06,366.66Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,300.31H155.6l-10.82,68.87h0a.9.9,0,0,0,.54.82,2.94,2.94,0,0,0,2.65,0,1,1,0,0,0,.53-.64h0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.34,302.3a7.11,7.11,0,0,0-1-.11l-9.44,59.9c1.36.73,2.34,1.28,3.7,2l12.83-60.47Q159.43,302.89,156.34,302.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chair--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.77,327.59c0-2.34-2.06-4.85-6.41-7.67-8-5.21-31.42-18.26-42.67-24.49a.09.09,0,0,0-.09-.09c-8.65-5.26-11.28-27.67-17.27-46.67-.13-.4-.26-.8-.39-1.18s-.21-.6-.31-.88c-.38-1-.77-2-1.18-2.85-.09-.2-.18-.39-.28-.58a19.08,19.08,0,0,0-1.24-2.22c-.11-.18-.23-.35-.34-.51s-.43-.59-.65-.87-.24-.3-.37-.44a7.69,7.69,0,0,0-.61-.66,5.94,5.94,0,0,0-.52-.49,9.59,9.59,0,0,0-1.61-1.18l-.42-.24,0,0-.1-.06c-.06,0-.12-.08-.19-.11l-1.78-1-.48-.27-.22-.13c-.28-.16-.51-.28-.63-.36a8,8,0,0,0-1.74-.8l-.6-.18-.69-.16a14.43,14.43,0,0,0-6.89.75c-.74.22-1.46.5-2.2.79h0a109.29,109.29,0,0,0-11.07,5.57,36.47,36.47,0,0,0-8.61,6.16,12.32,12.32,0,0,0-.87.9,24.36,24.36,0,0,0-1.63,2,0,0,0,0,1,0,0,26.35,26.35,0,0,0-2.45,4c-.22.43-.41.88-.61,1.33a42.14,42.14,0,0,0-3,13.06c-.85,10,0,29.16,2,43.66h0c2.94,24.24,6.55,24.28,11.81,28.34,9,7,29.37,16.78,38,20.16,15.55,6.12,28.26-3.32,37.74-8a218.93,218.93,0,0,0,25.1-14.87c2.36-1.72,3.59-3.46,3.57-5.3C218.76,331.34,218.77,328.36,218.77,327.59Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.77,327.59c0-2.34-2.06-4.85-6.41-7.67-8-5.21-31.42-18.26-42.67-24.49a.09.09,0,0,0-.09-.09c-8.65-5.26-11.28-27.67-17.27-46.67-.13-.4-.26-.8-.39-1.18s-.21-.6-.31-.88c-.38-1-.77-2-1.18-2.85-.09-.2-.18-.39-.28-.58a19.08,19.08,0,0,0-1.24-2.22c-.11-.18-.23-.35-.34-.51s-.43-.59-.65-.87-.24-.3-.37-.44a7.69,7.69,0,0,0-.61-.66,5.94,5.94,0,0,0-.52-.49,9.59,9.59,0,0,0-1.61-1.18l-.42-.24,0,0-.1-.06c-.06,0-.12-.08-.19-.11l-1.78-1-.48-.27-.22-.13c-.28-.16-.51-.28-.63-.36a8,8,0,0,0-1.74-.8l-.6-.18-.69-.16a14.43,14.43,0,0,0-6.89.75c-.74.22-1.46.5-2.2.79h0a109.29,109.29,0,0,0-11.07,5.57,36.47,36.47,0,0,0-8.61,6.16,12.32,12.32,0,0,0-.87.9,24.36,24.36,0,0,0-1.63,2,0,0,0,0,1,0,0,26.35,26.35,0,0,0-2.45,4c-.22.43-.41.88-.61,1.33a42.14,42.14,0,0,0-3,13.06c-.85,10,0,29.16,2,43.66h0c2.94,24.24,6.55,24.28,11.81,28.34,9,7,29.37,16.78,38,20.16,15.55,6.12,28.26-3.32,37.74-8a218.93,218.93,0,0,0,25.1-14.87c2.36-1.72,3.59-3.46,3.57-5.3C218.76,331.34,218.77,328.36,218.77,327.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.09,347.72a218,218,0,0,0,25.1-14.87c5.39-3.91,4.9-7.91-2.83-12.93C201.63,313,163.52,292,163.52,292s-55.3,32.64-52.92,38.67,31,20.8,41.76,25C167.91,361.84,180.62,352.4,190.09,347.72Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.09,347.72a218,218,0,0,0,25.1-14.87c5.39-3.91,4.9-7.91-2.83-12.93C201.63,313,163.52,292,163.52,292s-55.3,32.64-52.92,38.67,31,20.8,41.76,25C167.91,361.84,180.62,352.4,190.09,347.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M174.34,355.47c6-2.19,11.23-5.51,15.75-7.75a218,218,0,0,0,25.1-14.87c.16-.11.29-.22.43-.33a12.11,12.11,0,0,0-3.19-4.67c-7-6.71-31.66-24.77-42.83-24.5s-42.76,16-46.21,18.71c-5.88,4.59-2.67,9.8,3.14,13.23s24.57,13.4,35.3,17.07A111.64,111.64,0,0,0,174.34,355.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.48,236.61c-5.82-3.06-13.38,1.1-22.74,6.23-6,3.28-11.1,7.17-14.21,14.46l-4-2.28c3.11-7.26,8.2-11.15,14.18-14.43,9.61-5.26,17.32-9.48,23.2-6C141.47,234.92,143.51,236.06,144.48,236.61Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.48,236.61c-5.82-3.06-13.38,1.1-22.74,6.23-6,3.28-11.1,7.17-14.21,14.46l-4-2.28c3.11-7.26,8.2-11.15,14.18-14.43,9.61-5.26,17.32-9.48,23.2-6C141.47,234.92,143.51,236.06,144.48,236.61Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.33,248.67c-1.54-4.65-3.49-9.69-8-12.12-7.62-3-13.56,1.75-22.62,6.29-5.23,2.79-10.09,6.57-12.95,11.88-9,15.56-3.19,70.45,3.12,77.84,0,0-.87-5.32,10.51-12.49,7.74-4.86,13.17-8.95,21.42-13,20.12-9.88,25.76-11.73,25.76-11.73C161,290.08,158.32,267.67,152.33,248.67Z",
    style: {
      fill: "#BA68C8"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--bottom--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.58,300.23s17,7.7,27,13.33c12.68,7.13,17.37,7,16.65,26.69-.64,17.21-2.66,39.26-1.94,49-4.74,5.07-14.35,10.49-16.39,1.43l-.38-1.21a13.2,13.2,0,0,0,.69-2.9l0-1.27c.25-8.62-3.67-33.15-3.61-43.53l-44.83-22.44Z",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.12,413.18a3.6,3.6,0,0,1-1.05,2.89c-1,.85-4.49,3.29-12.24,1.34-7.45-1.88-11.09-6.4-12.22-8.74s-2.11-4.61-3.3-6.56a13.09,13.09,0,0,0-4.56-3.9c-.92-.57-1.2-1.78-1.1-3.52C205.54,392.79,239.12,413.18,239.12,413.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.06,380.91l.06,1.82a4.09,4.09,0,0,0,1.26,2.6c1.26,1.24,2.57,2.44,3.85,3.66a.52.52,0,0,0,.39.19c.27,0,.33-.4.29-.67a14.6,14.6,0,0,1-.33-2.35c0-2.76,4.16-3.42,6.3-3.37,1.92,0,4.41.86,4.85,3,.77,3.79,4.73,11.36,6.27,13.53a41.44,41.44,0,0,0,4.09,5.1c1.61,1.74,5.33,4.7,4.26,7.57s-3.84,4.33-7.75,4.17a22.81,22.81,0,0,1-14.17-6c-3-3-5.1-8-6.13-9.53-1.87-2.82-5.55-4.1-6.51-5.53-.69-1.75-.48-4.31.58-6.92a44.85,44.85,0,0,0,1.73-4.59C207.46,382.27,207.1,380.81,208.06,380.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.32,403a10.61,10.61,0,0,1,5.13.73s1.54,1.21,2.34,1.75c2.54,1.72,3.86,3.87,2.79,6.74s-3.81,4.27-7.72,4.11c-3.59-.14-9.68-1.46-13.37-5.24C219.71,407,223.86,403.53,229.32,403Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.28,342.61l-35.29-13L149.43,307.5,177.82,297s29.69,14.25,38.38,19.26,11,6.53,10.69,20.33c-.27,10.77-2.64,40.37-2.64,40.37s-4.85,2.67-16.58-.59c0,0-2.94-17.26-3.83-24.16C203.35,348.4,203.28,342.61,203.28,342.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.92,377c-1.49-9.72-4-28.17-2.9-35.71.68-4.65-5-6.41-10.41-10.26s-20.78-12.94-20.78-12.94,3.27-6,1.61-10.17l-14.79,13.56,7.71,8.92h0l32.92,12.24s.07,5.79.56,9.63c.89,6.9,3.83,24.16,3.83,24.16Q208.84,376.73,209.92,377Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.92,376.3s2.25,2.25,9.57,2.39,8.07-1.4,8.07-1.4l.48-6.05a23.75,23.75,0,0,1-9.06,1.45,22.26,22.26,0,0,1-9.65-2.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.91,311.55s14.53,7.35,24.35,13.28c9.51,5.74,22.4,11.77,19.53,28.92-2.85,17-5.88,38.33-5.54,48.1-4.93,4.89-14.74,9.93-16.43.8l-.34-1.22a12.53,12.53,0,0,0,.81-2.88v-1.26c.59-8.61-1.38-32.73-.92-43.1L132.3,329.76Z",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.58,354.23s-27.75-11.5-41.22-20.46c-14.43-9.61-15.44-19.76-15.17-35.58l57.61-.6c1.41,10.28-1.43,16.5-7.31,20.22l20.75,12.48c7.21,5.31,10.06,6.85,9.39,17.61s-5.88,42.58-5.88,42.58c-5.15,1.24-11.69,1.18-16.39-1C177.69,378,174.78,362.7,176.58,354.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.13,389.72s1.89,1.93,9.2,2.06,8.07-1.4,8.07-1.4l.49-6a23.75,23.75,0,0,1-9.06,1.45,19,19,0,0,1-9.17-2.29Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.19,426.33a3.61,3.61,0,0,1-1.17,2.84c-1.07.81-4.61,3.11-12.28.86-7.37-2.16-10.84-6.82-11.87-9.2s-1.93-4.69-3-6.68a13.13,13.13,0,0,0-4.41-4.08c-.79-.8-1-1.94-1-3.55C175.42,404.65,208.19,426.33,208.19,426.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4,392.87v1.83a4.12,4.12,0,0,0,1.15,2.64c1.21,1.29,2.48,2.54,3.71,3.8.11.11.23.23.38.22s.35-.39.32-.67a14.53,14.53,0,0,1-.24-2.36c.16-2.75,4.29-3.26,6.42-3.12,1.92.13,4.38,1,4.74,3.2.62,3.82,4.29,11.53,5.73,13.76a43.53,43.53,0,0,0,3.9,5.26c1.53,1.79,5.14,4.89,4,7.72s-4,4.18-7.91,3.87a22.82,22.82,0,0,1-13.92-6.56c-2.88-3.1-4.79-8.19-5.76-9.77-1.76-2.88-5.39-4.3-6.29-5.77-.62-1.78-.31-4.33.84-6.9a39.89,39.89,0,0,0,1.91-4.52C177.75,394.21,177.44,392.74,178.4,392.87Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.79,415.77a10.55,10.55,0,0,1,5.09.92s1.5,1.27,2.28,1.84c2.47,1.81,3.71,4,2.53,6.84s-4,4.13-7.88,3.81c-3.59-.28-9.61-1.84-13.16-5.76C189,419.36,193.31,416.09,198.79,415.77Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M181,281.65c-8.47-7.9-17.53-20.76-17.53-20.76l1.5-23.24s5.93-.5,10.89,6.55c4.65,6.62,4.67,6.61,13.13,19.43,0,0,7.57-11.72,8.69-14.49a21.26,21.26,0,0,0,.7-3.26c.83-5.29,3.94-9.81,7.21-13.91.56-.7,1.13-1.4,1.7-2.09a10.84,10.84,0,0,0,.79-1c.22-.35.42-.64.92-.5a1.55,1.55,0,0,1,.82.7,4.4,4.4,0,0,1,.26,3.54,22,22,0,0,1-1.53,3.31c-.42.83.63.65,1.11.49,2.37-.79,4.91-3.83,6.49-5.69a33.31,33.31,0,0,1,3.08-3.71,4.94,4.94,0,0,1,2.66-1.27c.67-.07,1.32.1,1.32.94a3.49,3.49,0,0,1-.51,1.48,3.63,3.63,0,0,0-.54,2.94,8.72,8.72,0,0,1,.65,2.07c0,.92-.42,1.8-.46,2.72a19.22,19.22,0,0,0,.42,2.31,6.73,6.73,0,0,1-.91,2.68,22.31,22.31,0,0,1-3.12,4.91,43,43,0,0,1-6.44,6.06,15.62,15.62,0,0,0-3.57,5c-.76,1.8-1.75,5.32-2.21,6.93-.57,2-3.8,15.21-9.1,21.43C194,289.16,189.46,289.54,181,281.65Z",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,263.63c-2.24,3.27-3.82,8.9-3,11.86-1.27-3.08-.83-8.1,2.25-13Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.46,236.39c7,.24,9.82,3.79,13.16,8.59s10.19,15,10.19,15a24.32,24.32,0,0,1-4.63,10.25,27.84,27.84,0,0,1-7.61,6.37l-10.31-10.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.48,238.53a10.86,10.86,0,0,1-1,9.88s2.3-1,2.55-4.76C210.28,240.26,209.36,239.42,208.48,238.53Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.59,242.67c-3.64,2.53-11.13,20.49-9.23,64.93,13.41,9.28,56.34,5.18,59.64-10,0,0-1.9-3.43-2.38-17.52-.36-10.46-.06-15.94-.68-24.16-.81-10.59-5-17.85-11.27-19.33-6.78-1.59-17.44,0-17.44,0S136.68,238.56,128.59,242.67Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.14,236.38a33.48,33.48,0,0,1,7.42.69c6,1.41,10.09,8.47,10.88,18.88.37,4.87.41,8.79.46,13.34,0,3.07.07,6.55.22,10.8.43,12.49,2,16.69,2.35,17.56C176.25,307,158,312,141.92,312c-9.57,0-17.59-1.71-22.07-4.7-1.93-45.82,6-62.09,9-64.23,7.92-4,18.37-6,18.46-6a75.2,75.2,0,0,1,9.83-.7m0-.5a76.72,76.72,0,0,0-9.91.7s-10.55,2-18.64,6.09c-3.64,2.53-11.13,20.49-9.23,64.93,4.8,3.32,13.37,4.93,22.56,4.93,16.49,0,35-5.18,37.08-14.94,0,0-1.9-3.43-2.38-17.52-.36-10.46-.06-15.94-.68-24.16-.81-10.59-5-17.85-11.27-19.33a34.28,34.28,0,0,0-7.53-.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.92,232.69c-1.58-6.81-7-7.38-9.9-14.35-4-9.52-6.54-19.79,4-24.6.48-3.66,6.43-7.94,11.54-8.77a27.82,27.82,0,0,1,10.83.45,35.07,35.07,0,0,0,12.17.87c1.63-.19,3.39-.47,4.86.28a4.62,4.62,0,0,1,2.3,4,7.64,7.64,0,0,1-1.59,4.51,4,4,0,0,1,0,7.69,4.75,4.75,0,0,1-1,5.32,8.44,8.44,0,0,1-5.19,2.27c.05,0-1.05,3.85-1.21,4.21a15.94,15.94,0,0,1-2.46,3.83,15.44,15.44,0,0,1-3.43,3C158.41,222.32,139.7,232.66,138.92,232.69Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,217a1.51,1.51,0,0,1-.23.21c-1.29.89-1.34-1.4-2.68-2.88a4.23,4.23,0,0,0-3-1.48,5,5,0,0,0-4.54,3c-1.23,2.81.37,8.19,4.09,9.36a4.38,4.38,0,0,0,5.22-1.83l.87,17.48A17.46,17.46,0,0,0,152.59,247c6.16-.09,10.48-2.25,5.9-7.2l-.23-4.44a17.88,17.88,0,0,0,6.23-1.06,12.87,12.87,0,0,0,8-10.37c.5-3.31-.6-6.2-.69-9.53-.06-2,0-5.12-.11-6.4-.11-1.58-1-7.84-2.82-9.92-2.52,4.44-14.66,6-23.65,2.64a13.82,13.82,0,0,1-1.44,6.87c-1.17,2.37-2.15,3.1-4.36,4.61a7.8,7.8,0,0,1,0,3.72A2.41,2.41,0,0,1,139,217Z",
    style: {
      fill: "#ffc4c3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.86,207.71l-4.19,2.95a2.69,2.69,0,0,1,.66-3.66A2.48,2.48,0,0,1,152.86,207.71Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.21,214a2,2,0,1,0,1.78-2.19A2,2,0,0,0,151.21,214Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.34,225.23a1.32,1.32,0,1,0,1.18-1.45A1.32,1.32,0,0,0,157.34,225.23Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.41,212.15a2,2,0,1,0,1.78-2.2A2,2,0,0,0,164.41,212.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.45,207.57l-4.86-1.75a2.47,2.47,0,0,1,3.22-1.6A2.71,2.71,0,0,1,168.45,207.57Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.66 211.84 161.84 221.03 166.89 218.04 159.66 211.84",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.26,235.34s-7.76-.25-13.15-3.26a12.53,12.53,0,0,1-4.8-5.78s1,4,3,6.06c5.25,5.39,15.09,5.58,15.09,5.58Z",
    style: {
      fill: "#ffa8a7"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "284.85 361.58 220.99 324.75 220.99 328.64 284.85 365.47 284.85 361.58",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.85 357.68 220.99 320.86 220.99 324.75 284.85 361.58 284.85 357.68",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 410.7 135.09 377.29 132.14 379.47 193.05 414.6 193.05 410.7",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 382.57 193.05 460.54 190.09 458.84 190.09 380.86 193.05 382.57",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 382.57 193.05 460.54 196 458.84 196 380.86 193.05 382.57",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.14 347.44 132.14 425.42 129.19 423.71 129.19 345.74 132.14 347.44",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.14 347.44 132.14 425.42 135.09 423.71 135.09 345.74 132.14 347.44",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 414.6 129.19 377.77 129.19 381.66 193.05 418.49 193.05 414.6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.9 331.25 281.9 409.22 278.95 407.52 278.95 329.54 281.9 331.25",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "281.9 331.25 281.9 409.22 284.85 407.52 284.85 329.54 281.9 331.25",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 366.8 193.05 387.82 129.19 351 129.19 329.97 193.05 366.8",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 387.82 284.85 334.8 284.85 324.29 193.05 377.31 193.05 387.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--desk--inject-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 377.31 120.08 335.23 220.99 276.94 293.95 319.03 193.05 377.31",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 377.31 120.08 335.23 220.99 276.94 293.95 319.03 193.05 377.31",
    style: {
      opacity: 0.05
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.08 335.23 120.08 340.48 193.05 382.57 193.05 377.31 120.08 335.23",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.08 335.23 120.08 340.48 193.05 382.57 193.05 377.31 120.08 335.23",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 382.57 293.95 324.29 293.95 319.03 193.05 377.31 193.05 382.57",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "193.05 382.57 293.95 324.29 293.95 319.03 193.05 377.31 193.05 382.57",
    style: {
      opacity: 0.25
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Notebook--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M188.92,305.17l-33.74,19.48a.53.53,0,0,0,0,1l41.15,23.69a1.93,1.93,0,0,0,1.75,0l33.73-19.48a.52.52,0,0,0,0-1l-41.15-23.7A2,2,0,0,0,188.92,305.17Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--notebook--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.44,306.9l-29,15.25-.59.94v.75a1.08,1.08,0,0,0,.59.94l38.18,22a2.11,2.11,0,0,0,2,0L227,330.47v-.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.64,346.31a2,2,0,0,1-1-.24l-38.18-22a1,1,0,0,1,0-1.88l27.7-16L227,329.72l-28.32,16.35A2,2,0,0,1,197.64,346.31Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.16,304l-27.37,15.81-.29.39v2.94h0a.49.49,0,0,0,.29.39l38.17,22a1.48,1.48,0,0,0,1.36,0l27.38-15.8v-2.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.7,326.78l-.34.2-4.45,2.57-.83.48-21.75,12.56a1.55,1.55,0,0,1-1.36,0l-38.19-22a.41.41,0,0,1,0-.78l.37-.21,27-15.6,39.21,22.63.08.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.64,342.75v2.94a1.33,1.33,0,0,1-.67-.17l-38.19-22a.48.48,0,0,1-.27-.39v-2.94a.48.48,0,0,0,.27.39l38.19,22A1.33,1.33,0,0,0,197.64,342.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.7,326.39l-4.93,2.84-.77.45-21.67,12.51a1.48,1.48,0,0,1-1.36,0l-34.19-19.74-.87-.49a8.52,8.52,0,0,1-2.76-2.41.86.86,0,0,0-.07-.1.6.6,0,0,1-.08-.21.61.61,0,0,1,.48-.69,12.88,12.88,0,0,0,2.57-1.07l0,0,24.07-13.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.6,326c-.35.21-.35.54,0,.74a1.42,1.42,0,0,0,1.27,0c.35-.2.35-.53,0-.74A1.42,1.42,0,0,0,220.6,326Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.68,323.66a1.69,1.69,0,0,0-1.71.12,5.35,5.35,0,0,0-2.14,3.09,1.17,1.17,0,0,0,.46.06,4.79,4.79,0,0,1,1.92-2.74A1.56,1.56,0,0,1,224,324a.93.93,0,0,1,.46.12,1.77,1.77,0,0,1,.64,1.57c0,.13,0,.25,0,.38l.44.26a4.72,4.72,0,0,0,.05-.64A2.18,2.18,0,0,0,224.68,323.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.47,326.52a.43.43,0,0,1,0,.11l-.08-.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.78,323.83c-.35.21-.35.54,0,.74a1.42,1.42,0,0,0,1.27,0c.35-.2.35-.53,0-.74A1.42,1.42,0,0,0,216.78,323.83Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.86,321.45a1.69,1.69,0,0,0-1.71.12,5.32,5.32,0,0,0-2.15,3.09,1.22,1.22,0,0,0,.47.06,4.78,4.78,0,0,1,1.91-2.74,1.59,1.59,0,0,1,.78-.24.9.9,0,0,1,.46.12,1.74,1.74,0,0,1,.64,1.57,2.42,2.42,0,0,1,0,.38l.45.26a4.68,4.68,0,0,0,0-.64A2.21,2.21,0,0,0,220.86,321.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,321.62c-.35.21-.35.54,0,.74a1.42,1.42,0,0,0,1.27,0c.35-.2.35-.53,0-.74A1.42,1.42,0,0,0,213,321.62Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,319.24a1.69,1.69,0,0,0-1.71.12,5.32,5.32,0,0,0-2.15,3.09,1.24,1.24,0,0,0,.47.06,4.74,4.74,0,0,1,1.92-2.74,1.56,1.56,0,0,1,.77-.24.9.9,0,0,1,.46.12,1.74,1.74,0,0,1,.65,1.57,2.34,2.34,0,0,1,0,.38l.45.26a4.72,4.72,0,0,0,0-.64A2.19,2.19,0,0,0,217,319.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.12,319.41c-.35.21-.35.54,0,.74a1.42,1.42,0,0,0,1.27,0c.35-.2.35-.53,0-.74A1.42,1.42,0,0,0,209.12,319.41Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.2,317a1.69,1.69,0,0,0-1.71.12,5.38,5.38,0,0,0-2.14,3.09,1.17,1.17,0,0,0,.46.06,4.79,4.79,0,0,1,1.92-2.74,1.59,1.59,0,0,1,.78-.24.93.93,0,0,1,.46.12,1.75,1.75,0,0,1,.64,1.58c0,.12,0,.25,0,.37l.44.26a3.41,3.41,0,0,0,.05-.63A2.2,2.2,0,0,0,213.2,317Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.3,317.21a.39.39,0,0,0,0,.73,1.36,1.36,0,0,0,1.27,0,.39.39,0,0,0,0-.73A1.36,1.36,0,0,0,205.3,317.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.38,314.83a1.69,1.69,0,0,0-1.71.11,5.35,5.35,0,0,0-2.15,3.09,1.22,1.22,0,0,0,.47.06,4.84,4.84,0,0,1,1.91-2.74,1.7,1.7,0,0,1,.78-.24.9.9,0,0,1,.46.12,1.75,1.75,0,0,1,.64,1.58,2.3,2.3,0,0,1,0,.37l.45.26a4.58,4.58,0,0,0,0-.63A2.19,2.19,0,0,0,209.38,314.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.47,315a.39.39,0,0,0,0,.73,1.36,1.36,0,0,0,1.27,0,.39.39,0,0,0,0-.73A1.36,1.36,0,0,0,201.47,315Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.55,312.62a1.67,1.67,0,0,0-1.71.12,5.3,5.3,0,0,0-2.15,3.08,1.24,1.24,0,0,0,.47.06,4.81,4.81,0,0,1,1.92-2.74,1.67,1.67,0,0,1,.78-.24,1,1,0,0,1,.45.12,1.75,1.75,0,0,1,.65,1.58c0,.12,0,.25,0,.37l.44.26a4.58,4.58,0,0,0,.05-.63A2.17,2.17,0,0,0,205.55,312.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.64,312.79a.39.39,0,0,0,0,.73,1.36,1.36,0,0,0,1.27,0c.36-.2.36-.53,0-.73A1.36,1.36,0,0,0,197.64,312.79Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.72,310.41a1.65,1.65,0,0,0-1.7.12,5.29,5.29,0,0,0-2.15,3.09,1.42,1.42,0,0,0,.47.05,4.8,4.8,0,0,1,1.91-2.74,1.68,1.68,0,0,1,.78-.23,1,1,0,0,1,.46.11,1.75,1.75,0,0,1,.64,1.58c0,.12,0,.25,0,.37l.45.26a4.44,4.44,0,0,0,0-.63A2.17,2.17,0,0,0,201.72,310.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.82,310.58a.39.39,0,0,0,0,.73,1.36,1.36,0,0,0,1.27,0,.39.39,0,0,0,0-.73A1.36,1.36,0,0,0,193.82,310.58Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.9,308.2a1.67,1.67,0,0,0-1.71.12,5.29,5.29,0,0,0-2.15,3.09,1.45,1.45,0,0,0,.47,0,4.78,4.78,0,0,1,1.91-2.73,1.59,1.59,0,0,1,.78-.24.9.9,0,0,1,.46.12,1.73,1.73,0,0,1,.64,1.57,2.48,2.48,0,0,1,0,.38l.45.25a4.46,4.46,0,0,0,.05-.63A2.17,2.17,0,0,0,197.9,308.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190,308.37a.39.39,0,0,0,0,.73,1.36,1.36,0,0,0,1.27,0,.39.39,0,0,0,0-.73A1.36,1.36,0,0,0,190,308.37Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.07,306a1.67,1.67,0,0,0-1.71.12,5.33,5.33,0,0,0-2.15,3.09,1.48,1.48,0,0,0,.47.05,4.8,4.8,0,0,1,1.92-2.73,1.56,1.56,0,0,1,.78-.24.87.87,0,0,1,.45.12,1.73,1.73,0,0,1,.65,1.57c0,.12,0,.25,0,.38l.44.25a4.46,4.46,0,0,0,0-.63A2.17,2.17,0,0,0,194.07,306Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.16,306.16c-.35.2-.35.53,0,.74a1.42,1.42,0,0,0,1.27,0c.36-.21.36-.54,0-.74A1.42,1.42,0,0,0,186.16,306.16Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.24,303.78a1.65,1.65,0,0,0-1.7.12,5.29,5.29,0,0,0-2.15,3.09,1.22,1.22,0,0,0,.47.05,4.74,4.74,0,0,1,1.91-2.73,1.59,1.59,0,0,1,.78-.24.9.9,0,0,1,.46.12,1.73,1.73,0,0,1,.64,1.57,2.42,2.42,0,0,1,0,.38l.45.25a4.44,4.44,0,0,0,0-.63A2.17,2.17,0,0,0,190.24,303.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.82,338.26a.44.44,0,0,1-.38-.22.45.45,0,0,1,.16-.59l21.06-12.16a.43.43,0,0,1,.59.16.44.44,0,0,1-.15.59L194,338.2A.39.39,0,0,1,193.82,338.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.27,336.78a.43.43,0,0,1-.38-.21.45.45,0,0,1,.16-.59l21.06-12.16a.43.43,0,0,1,.44.74l-21.07,12.16A.39.39,0,0,1,191.27,336.78Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.72,335.31a.44.44,0,0,1-.38-.22.43.43,0,0,1,.16-.59l21.06-12.16a.44.44,0,0,1,.59.16.43.43,0,0,1-.16.59l-21.06,12.16A.42.42,0,0,1,188.72,335.31Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.16,333.84a.44.44,0,0,1-.37-.22A.43.43,0,0,1,186,333L207,320.87a.43.43,0,1,1,.43.75l-21.06,12.16A.43.43,0,0,1,186.16,333.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.61,332.36a.42.42,0,0,1-.37-.21.43.43,0,0,1,.16-.59l21.06-12.16a.43.43,0,0,1,.59.15.43.43,0,0,1-.16.59l-21.06,12.17A.54.54,0,0,1,183.61,332.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.06,330.89a.44.44,0,0,1-.37-.21.43.43,0,0,1,.16-.59l21.06-12.16a.44.44,0,0,1,.59.15.43.43,0,0,1-.16.59l-21.06,12.16A.43.43,0,0,1,181.06,330.89Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.51,329.42a.42.42,0,0,1-.37-.22.43.43,0,0,1,.15-.59l21.07-12.16a.43.43,0,0,1,.43.75l-21.06,12.16A.46.46,0,0,1,178.51,329.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,328a.42.42,0,0,1-.37-.22.43.43,0,0,1,.15-.59L196.81,315a.43.43,0,1,1,.43.75l-21.06,12.16A.46.46,0,0,1,176,328Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.41,326.47a.43.43,0,0,1-.22-.8l21.07-12.16a.44.44,0,0,1,.59.15.45.45,0,0,1-.16.59l-21.07,12.16A.39.39,0,0,1,173.41,326.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.86,325a.44.44,0,0,1-.38-.22.45.45,0,0,1,.16-.59L191.71,312a.43.43,0,0,1,.58.16.43.43,0,0,1-.15.59l-21.07,12.16A.39.39,0,0,1,170.86,325Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.31,323.53a.44.44,0,0,1-.38-.22.43.43,0,0,1,.16-.59l21.06-12.16a.43.43,0,0,1,.59.16.44.44,0,0,1-.15.59l-21.07,12.16A.42.42,0,0,1,168.31,323.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.75,322.05a.43.43,0,0,1-.21-.8l21.06-12.16a.43.43,0,0,1,.44.74L166,322A.54.54,0,0,1,165.75,322.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.2,320.58a.45.45,0,0,1-.37-.21.43.43,0,0,1,.16-.59l21.06-12.17a.45.45,0,0,1,.59.16.43.43,0,0,1-.16.59l-21.06,12.16A.43.43,0,0,1,163.2,320.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.41,339.73a.44.44,0,0,1-.38-.22.45.45,0,0,1,.16-.59L218.47,326a.43.43,0,0,1,.59.15.43.43,0,0,1-.16.59l-22.28,12.89A.39.39,0,0,1,196.41,339.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.54,323.72a1.8,1.8,0,0,0-.86-.56c-.12-.05-.26-.13-.41-.21-.2-.31-.45-.82-.11-.88s.6.17.82.24.09-.14,0-.18c-.37-.15-1.09-.61-1.24,0a1,1,0,0,0,.08.58,1.34,1.34,0,0,0-.55-.1c-.18,0-.33,0-.39.23s0,.16,0,.25.14.17.18.18h-.2c-.26,0-1-.19-1.16.14-.07.14.09.33.07.38s-.53.2-.62.25,0,.17,0,.18a4.69,4.69,0,0,1-.76,0c-.43,0-1.47-.12-1.33.53,0,.07.07.06.08.17a.62.62,0,0,0,0,.16s0,0-.1.09-.18,0-.23.1c-.2.25.11.33-.14.49s-1.09-.23-1.44,0,.09.85-.47.86c-.12,0-.05.19,0,.2.53,0,.47-.06.57-.48.17-.7,1.21-.22,1.79-.38a.11.11,0,0,0,.05-.16c-.16-.25,0-.38.25-.49a.1.1,0,0,0,.05-.15c-.07-.12-.29-.47-.15-.63a2.94,2.94,0,0,1,.62-.07,12.35,12.35,0,0,1,1.36,0,.09.09,0,0,0,.09-.12c-.07-.15.52-.24.65-.27a.1.1,0,0,0,.06-.13c-.28-.7.76-.44,1.19-.37a.1.1,0,0,0,.12-.13c-.07-.24-.59-.48,0-.56a.94.94,0,0,1,.48.11,3.28,3.28,0,0,0,1.08,1.11C207.44,324.33,207.86,324.19,207.54,323.72Zm-.19.12c.13.18-.27,0-.32,0a1.48,1.48,0,0,1-.54-.57l.32.17A1.23,1.23,0,0,1,207.35,323.84Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197,328.15c-.08-.3-.09-.63.2-.67.13,0,0-.2-.07-.21-.38,0-.5.32-.45.72a2.38,2.38,0,0,0-.47-.16c-.25-.05-.41-.05-.49.2s.07.25.06.38.19.12-.11.2a1.45,1.45,0,0,1-.35,0,.54.54,0,0,0-.51.16c-.19.16.27.24-.28.15a.9.9,0,0,0-.43-.06c-.2,0-.31.1-.27.33s.23.23.23.29c0,.49-.53.08-.73,0a.09.09,0,0,0-.12.08c0,.24.16.32-.19.35a3.42,3.42,0,0,0-.36-.14c-.22,0-.43.29-.72.27-.08,0-.11.07-.08.13.08.22.2.35-.24.54l-.51-.06c-.13,0-.05.2,0,.21s.88.3,1.08,0-.14-.43-.07-.56c0,.08.39-.12.44-.14a1.69,1.69,0,0,1,.34-.09c.06,0,.11.1.18.1s.17,0,.25,0,.1-.14.13-.16-.1-.11,0-.16.2.07.31.1.41.18.55,0-.15-.39-.12-.54c.07-.35.56-.09.79-.24a.11.11,0,0,0,0-.11c-.14-.47.73-.1,1-.15.05,0,.1,0,.09-.1a2.45,2.45,0,0,0-.11-.3c.07-.29.47-.25.65-.21.17.58.63,1.17,1.13,1a.08.08,0,0,0,.07-.08C197.92,328.82,197.48,328.42,197,328.15Zm.18.48s0-.08-.07-.14a1.32,1.32,0,0,1,.36.35C197.57,329.13,197.24,328.71,197.19,328.63Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M204.66,331.26a1.85,1.85,0,0,0-.86-.55l-.41-.21c-.2-.31-.46-.82-.11-.88.2,0,.59.17.82.24s.09-.15,0-.18c-.37-.15-1.09-.61-1.24,0a.88.88,0,0,0,.08.58,1.22,1.22,0,0,0-.55-.1c-.18,0-.33,0-.39.23s0,.16,0,.25.14.17.18.18l-.2,0c-.27,0-1-.18-1.16.15-.07.13.09.32.07.38s-.53.19-.62.25,0,.17,0,.18a6.2,6.2,0,0,1-.76,0c-.43,0-1.47-.13-1.33.52,0,.07.07.06.08.18a.62.62,0,0,0,0,.16s0,0-.1.08-.18,0-.23.1c-.2.25.11.34-.14.5s-1.09-.23-1.44,0,.09.85-.47.86c-.12,0,0,.19,0,.19.53,0,.47-.05.57-.48.16-.7,1.21-.21,1.79-.38.07,0,.08-.1.05-.15-.16-.25,0-.38.25-.49a.1.1,0,0,0,0-.15c-.07-.12-.29-.47-.15-.63a2.86,2.86,0,0,1,.62-.07,12.35,12.35,0,0,1,1.36,0c.06,0,.11-.07.09-.13s.52-.24.65-.27a.09.09,0,0,0,.06-.12c-.28-.7.75-.44,1.18-.37a.1.1,0,0,0,.12-.14c-.06-.23-.58-.47,0-.56a1.12,1.12,0,0,1,.48.12,3.36,3.36,0,0,0,1.07,1.11C204.56,331.88,205,331.74,204.66,331.26Zm-.19.13c.13.17-.27,0-.32,0a1.55,1.55,0,0,1-.54-.57,3.16,3.16,0,0,0,.32.16A1.34,1.34,0,0,1,204.47,331.39Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.14,325.91c-.08-.3-.09-.64.19-.67s0-.21-.06-.21c-.38,0-.5.32-.45.72a1.87,1.87,0,0,0-.47-.16c-.25,0-.41-.06-.49.2s.07.25.06.38.19.12-.11.2a2.21,2.21,0,0,1-.35,0,.54.54,0,0,0-.51.16c-.19.16.27.23-.28.14a1,1,0,0,0-.43-.05c-.2,0-.31.1-.27.32s.23.24.23.3c0,.49-.53.08-.73,0a.09.09,0,0,0-.12.08c0,.24.16.32-.19.34,0,0-.28-.13-.36-.13s-.43.29-.72.27c-.08,0-.11.06-.08.13.08.22.2.35-.24.54l-.51-.07c-.13,0-.05.21.05.22s.88.3,1.08,0-.14-.44-.07-.56c-.05.08.39-.12.44-.14a1.21,1.21,0,0,1,.34-.09c.06,0,.11.1.18.1s.17,0,.25,0,.09-.14.12-.16-.1-.11.06-.17.2.08.31.11.41.17.55,0-.15-.39-.12-.55c.07-.34.56-.08.79-.23a.11.11,0,0,0,0-.11c-.14-.48.73-.1,1-.15.05,0,.1,0,.09-.1a2,2,0,0,0-.11-.3c.07-.29.46-.26.65-.21.17.58.63,1.17,1.13,1a.1.1,0,0,0,.07-.09C212.05,326.58,211.6,326.18,211.14,325.91Zm.18.48-.07-.14c.17.13.33.27.35.35C211.7,326.89,211.37,326.47,211.32,326.39Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M189.1,322.66a1.85,1.85,0,0,0-.86-.55l-.41-.21c-.2-.31-.46-.82-.11-.88.2,0,.59.17.81.24s.1-.15,0-.18c-.37-.15-1.09-.61-1.24,0a.9.9,0,0,0,.08.59,1.22,1.22,0,0,0-.55-.1c-.18,0-.33,0-.39.23s0,.16,0,.25.14.17.18.18l-.2,0c-.27,0-1-.18-1.16.15-.07.13.09.32.07.38s-.53.19-.62.25,0,.17,0,.18a6.2,6.2,0,0,1-.76,0c-.43,0-1.47-.13-1.33.52,0,.07.07.06.08.18a.62.62,0,0,0,0,.16s0,0-.1.08-.18,0-.23.1c-.2.25.11.34-.14.5s-1.09-.23-1.44,0,.09.85-.47.86c-.12,0-.05.19,0,.19.53.05.47-.05.57-.48.16-.7,1.21-.21,1.79-.38a.1.1,0,0,0,.05-.15c-.16-.25,0-.39.25-.49a.1.1,0,0,0,.05-.15c-.07-.12-.29-.47-.15-.63a2.94,2.94,0,0,1,.62-.07,12.35,12.35,0,0,1,1.36,0c.06,0,.11-.07.09-.13s.52-.24.65-.27a.09.09,0,0,0,.06-.12c-.28-.7.75-.44,1.19-.37a.11.11,0,0,0,.12-.14c-.07-.23-.59-.47,0-.56a1.09,1.09,0,0,1,.48.12,3.28,3.28,0,0,0,1.08,1.11C189,323.28,189.42,323.14,189.1,322.66Zm-.19.13c.13.17-.27,0-.32,0a1.55,1.55,0,0,1-.54-.57,3.16,3.16,0,0,0,.32.16A1.34,1.34,0,0,1,188.91,322.79Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M195.58,317.31c-.08-.3-.09-.64.19-.67s0-.21-.06-.21c-.38,0-.5.32-.45.72a1.87,1.87,0,0,0-.47-.16c-.25-.05-.41-.06-.49.2s.07.24.06.38.19.12-.11.2a2.21,2.21,0,0,1-.35,0,.54.54,0,0,0-.51.16c-.19.16.27.23-.28.14a1,1,0,0,0-.43,0c-.2,0-.31.1-.27.32s.23.24.23.3c0,.49-.53.08-.73,0a.09.09,0,0,0-.12.08c0,.24.16.32-.19.34,0,0-.28-.13-.36-.13s-.43.29-.72.27c-.08,0-.11.06-.08.13s.2.35-.24.54l-.51-.07c-.13,0-.05.21.05.22s.88.3,1.08,0-.14-.44-.07-.56c-.05.08.39-.12.44-.14a1.21,1.21,0,0,1,.34-.09c.06,0,.11.1.18.1s.17,0,.25,0,.09-.14.13-.16-.11-.11,0-.17.2.08.31.11.41.17.55,0-.15-.39-.12-.55c.07-.34.56-.08.79-.23a.11.11,0,0,0,0-.11c-.14-.48.73-.1,1-.15.05,0,.1,0,.09-.1a2,2,0,0,0-.11-.3c.07-.29.47-.26.65-.21.17.58.63,1.17,1.13,1a.1.1,0,0,0,.07-.09C196.49,318,196.05,317.58,195.58,317.31Zm.18.48-.07-.14a1.32,1.32,0,0,1,.36.35C196.14,318.29,195.81,317.87,195.76,317.79Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M190.7,327.86a1.71,1.71,0,0,0-.86-.55l-.41-.22c-.2-.31-.46-.82-.11-.88s.59.18.81.24.1-.14,0-.18c-.37-.14-1.09-.61-1.24,0a.91.91,0,0,0,.08.59,1.23,1.23,0,0,0-.55-.11c-.18,0-.33,0-.39.23a.49.49,0,0,0,0,.25c0,.13.14.17.18.18H188c-.27,0-1-.19-1.16.14-.07.14.09.33.07.38s-.53.2-.62.25,0,.17,0,.18a4.69,4.69,0,0,1-.76,0c-.43,0-1.47-.12-1.33.53,0,.07.07.06.08.17a.62.62,0,0,0,0,.16s0,0-.1.09-.18,0-.23.1c-.2.25.11.34-.14.49s-1.09-.22-1.44,0,.09.85-.47.86c-.12,0-.05.19,0,.2.53,0,.47-.05.57-.48.16-.7,1.21-.22,1.79-.38a.11.11,0,0,0,0-.16c-.16-.24,0-.38.25-.49a.1.1,0,0,0,.05-.15c-.07-.12-.29-.46-.15-.63a2.86,2.86,0,0,1,.62-.07,10.29,10.29,0,0,1,1.36,0,.11.11,0,0,0,.09-.13c-.07-.15.52-.24.65-.27a.1.1,0,0,0,.06-.13c-.28-.7.75-.44,1.18-.37.09,0,.15-.05.12-.13-.06-.24-.58-.48,0-.56a1,1,0,0,1,.48.11,3.26,3.26,0,0,0,1.07,1.11C190.6,328.48,191,328.33,190.7,327.86Zm-.19.12c.13.18-.27,0-.32,0a1.41,1.41,0,0,1-.54-.57l.32.17A1.23,1.23,0,0,1,190.51,328Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M195.83,323c-.08-.3-.08-.64.2-.67.13,0,0-.21-.06-.21-.39,0-.5.32-.46.72a1.87,1.87,0,0,0-.47-.16c-.25-.05-.41-.06-.49.19s.07.25.07.39.18.12-.12.19a2.26,2.26,0,0,1-.35,0c-.3,0-.33,0-.51.16s.28.23-.27.14a1.28,1.28,0,0,0-.43-.06c-.21.05-.31.11-.28.33s.23.24.23.3c0,.48-.53.07-.72,0a.1.1,0,0,0-.13.08c0,.24.16.32-.19.34,0,0-.28-.13-.35-.13-.23,0-.43.29-.73.27-.08,0-.1.06-.08.13s.2.35-.24.54l-.52-.07c-.11,0,0,.21.06.21s.89.31,1.09,0-.15-.43-.07-.56c0,.09.38-.11.43-.13a1,1,0,0,1,.34-.09c.06,0,.12.09.18.09s.18,0,.25,0,.1-.14.13-.16-.1-.12,0-.17.21.08.31.11.41.17.56,0-.16-.38-.13-.54c.07-.34.57-.08.79-.24,0,0,0-.06,0-.1-.14-.48.73-.1,1-.16.05,0,.1,0,.09-.09a2.08,2.08,0,0,0-.1-.3c.07-.29.46-.26.64-.21.18.58.64,1.17,1.14,1a.1.1,0,0,0,.06-.09C196.75,323.65,196.3,323.25,195.83,323Zm.18.48a.64.64,0,0,1-.06-.14,1.25,1.25,0,0,1,.35.35C196.4,324,196.06,323.54,196,323.46Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M201.7,319a.24.24,0,0,0,0-.12c-.08-.29-.42-.07-.48.11s.07.25.06.38.19.12-.11.2a1.45,1.45,0,0,1-.35,0,.54.54,0,0,0-.51.16c-.19.16.27.24-.28.15a1.24,1.24,0,0,0-.43-.06c-.2,0-.31.1-.28.33s.24.23.24.29c0,.49-.53.08-.73,0a.09.09,0,0,0-.12.07c0,.24.16.33-.19.35,0,0-.28-.13-.36-.14s-.43.3-.72.27c-.08,0-.11.07-.08.13.08.22.2.35-.24.54,0,0-.52-.06-.52-.06s0,.2.06.21.88.3,1.08,0-.14-.43-.07-.56c0,.08.39-.12.44-.14a1.69,1.69,0,0,1,.34-.09c.06,0,.11.1.17.1s.18,0,.26,0,.09-.14.12-.16-.1-.11.06-.16.2.07.31.1.41.18.55,0-.15-.39-.12-.54c.07-.35.56-.09.79-.24a.11.11,0,0,0,0-.11c-.14-.47.72-.1,1-.15,0,0,.1,0,.09-.1a1.39,1.39,0,0,1,0-.61A.89.89,0,0,0,201.7,319Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book-shelf--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-3",
    d: "M259,334.26l27.44-15.81a.76.76,0,0,0,0-1.43l-36.88-21.29a2.75,2.75,0,0,0-2.47,0l-27.43,15.82a.75.75,0,0,0,0,1.42l36.88,21.29A2.67,2.67,0,0,0,259,334.26Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.36 317.2 258.03 331.66 224.06 312.16 249.38 297.7 283.36 317.2",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.36 317.2 258.03 331.66 224.06 312.16 249.38 297.7 283.36 317.2",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.8,330.77l24.6-14.13a8.18,8.18,0,0,1,.11-5.14L258,325.5A20,20,0,0,0,257.8,330.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.05,323.9a4.16,4.16,0,0,0-1.91,3.28V331c0,1.21.85,1.7,1.91,1.1l24.31-14v-.95l-24.05,13.74c-.63.36-1.14.06-1.14-.66v-3.55a2.51,2.51,0,0,1,1.15-2l24-13.75v-1.07Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.05,323.9a4.16,4.16,0,0,0-1.91,3.28V331c0,1.21.85,1.7,1.91,1.1l24.31-14v-.95l-24.05,13.74c-.63.36-1.14.06-1.14-.66v-3.55a2.51,2.51,0,0,1,1.15-2l24-13.75v-1.07Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.36,309.94l-34-19.5-24.31,14a4.18,4.18,0,0,0-1.91,3.28v3.83a1.34,1.34,0,0,0,.56,1.23l34,19.5a1.32,1.32,0,0,1-.56-1.23v-3.83a4.21,4.21,0,0,1,1.9-3.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.36,309.94l-34-19.5-24.31,14a4.18,4.18,0,0,0-1.91,3.28v3.83a1.34,1.34,0,0,0,.56,1.23l34,19.5a1.32,1.32,0,0,1-.56-1.23v-3.83a4.21,4.21,0,0,1,1.9-3.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.7,325.31a3.78,3.78,0,0,0-.56,1.87V331a1.32,1.32,0,0,0,.56,1.23l-34-19.5a1.34,1.34,0,0,1-.56-1.23v-3.83a4,4,0,0,1,.56-1.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.36 307.57 258.03 322.04 224.06 302.54 249.38 288.07 283.36 307.57",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.8,321.15,282.4,307a8.18,8.18,0,0,1,.11-5.14l-24.48,14A19.91,19.91,0,0,0,257.8,321.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,314.27a4.2,4.2,0,0,0-1.9,3.28v3.84c0,1.21.85,1.7,1.9,1.09l24.32-14v-.95l-24.05,13.74c-.63.37-1.15.07-1.14-.65V317.1a2.54,2.54,0,0,1,1.15-2l24-13.74v-1.08Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,314.27a4.2,4.2,0,0,0-1.9,3.28v3.84c0,1.21.85,1.7,1.9,1.09l24.32-14v-.95l-24.05,13.74c-.63.37-1.15.07-1.14-.65V317.1a2.54,2.54,0,0,1,1.15-2l24-13.74v-1.08Z",
    style: {
      fill: "#fff",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.36,300.31l-34-19.49-24.31,13.95a4.22,4.22,0,0,0-1.91,3.29v3.83a1.33,1.33,0,0,0,.56,1.23l34,19.5a1.33,1.33,0,0,1-.56-1.23v-3.84a4.2,4.2,0,0,1,1.9-3.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.36,300.31l-34-19.49-24.31,13.95a4.22,4.22,0,0,0-1.91,3.29v3.83a1.33,1.33,0,0,0,.56,1.23l34,19.5a1.33,1.33,0,0,1-.56-1.23v-3.84a4.2,4.2,0,0,1,1.9-3.28Z",
    style: {
      fill: "#fff",
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.69,315.69a3.87,3.87,0,0,0-.55,1.86v3.84a1.33,1.33,0,0,0,.56,1.23l-34-19.5a1.33,1.33,0,0,1-.56-1.23v-3.83a3.89,3.89,0,0,1,.56-1.87Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.69,315.69a3.87,3.87,0,0,0-.55,1.86v3.84a1.33,1.33,0,0,0,.56,1.23l-34-19.5a1.33,1.33,0,0,1-.56-1.23v-3.83a3.89,3.89,0,0,1,.56-1.87Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.7,314.64l2.65,5.1a.18.18,0,0,1-.23.24l-5.24-2.46Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.12,320a.18.18,0,0,0,.23-.24l-.52-1h0a1,1,0,0,1-.74.69l-.09,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4,300.73l.38.37.46.45,16.64,16a2.59,2.59,0,0,0,1.75-.67,2.64,2.64,0,0,0,1.07-2.21l-16.63-16-.89-.85C165.73,298.41,163,301.31,162.4,300.73Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.85,302.14l.86.82c.24.25.91-.13,1.55-.69.86-.74,1.55-1.91,1.23-2.23l-.63-.61-.23-.21c.32.33-.38,1.49-1.23,2.23-.61.54-1.26.91-1.52.71h0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.07,302.34c.56.58,3.33-2.35,2.78-2.92l-.86-.82c.56.57-2.22,3.49-2.78,2.92Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4,300.73l.84.82c.55.56,3.25-2.23,2.83-2.88l0,0-.86-.82C165.73,298.41,163,301.31,162.4,300.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.31,320l0-.21-3.3-3.3-17.6-16.89c.05-.06,0-.09,0-.1-.73.84-1.73,1.61-2,1.28l.38.37.46.45,16.64,16h0l5.24,2.46A.18.18,0,0,0,185.31,320Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.81,297.28l3.59,3.45c.23.25.9-.12,1.54-.67.85-.74,1.56-1.9,1.24-2.24h0l-3.6-3.46c-.72-.69-2.29.6-2.82,1.75A1,1,0,0,0,158.81,297.28Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.17,297.15a3.13,3.13,0,0,0,1.55-2.29.69.69,0,0,0-.27-.6c-.76-.45-2.19.76-2.69,1.85a1,1,0,0,0,0,1.15C159.07,297.52,159.58,297.5,160.17,297.15Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.59,304a3.92,3.92,0,0,1,3.17,1.46c.94.9,2.5,1.35,2.51,1.92s-.91,1.2-.91,1.2Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--arm--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M167.58,319.62a10.25,10.25,0,0,0,6.14-1.91c.44-.34.85-.7,1.28-1a3.27,3.27,0,0,1,1.11-.72c.34-.1.69-.15,1-.26a2.76,2.76,0,0,0,1.72-1.76,3.52,3.52,0,0,1,.16-.49.64.64,0,0,1,.37-.35,1,1,0,0,1,.53.06,7.78,7.78,0,0,0,1.93.52,3.75,3.75,0,0,0,1.49-.18c.35-.13,1.06-.6.6-1-.62-.57-1.21-1.18-1.71-1.56-2.65-2-5.06-2.79-8.24-3.77-1.47-.44-3.56-.88-5-1.3-.63-.17-1.28-.44-1.94-.66l-1.34-1.29a4.58,4.58,0,0,0-1.54.18c-1,.32-1.71.64-2.91.95-2.48.65-7.05-.85-10.23-1.65-6.25-1.57-18.58-6.66-18.58-6.66l1.14-27.63c.15-10.63-1.13-22-4.25-25-4.24,1.06-9.63,3-12.77,7.23-2.18,2.95-3.29,8.4-3.72,14.9-.6,9-1.63,25.05-.94,35,.62,9,2.5,9.94,10.45,11.88,1.13.28,2.28.5,3.43.71,4.46.83,8.95,1.5,13.44,2.14q8,1.15,16,2.1C157.55,318.23,165,319.64,167.58,319.62Z",
    style: {
      fill: "#ffc4c3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M129.36,242.28c-3.59,1.57-8,3.31-11.08,6.71a23,23,0,0,0-5.54,12.27c-.59,3.71-1,21.51-1,21.51s3,3.27,9.93,3.28a32.47,32.47,0,0,0,11.68-2s.86-19,1.08-22.43C134.77,255.63,132.88,247.21,129.36,242.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.41,296.7a13.53,13.53,0,0,0-6.84.1,9,9,0,0,1,6.91-1.85Z",
    style: {
      fill: "#ffa8a7"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Backpack--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--backpack--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.36,327.2c-5.14-.38-13.26,4.74-15.3,8.63-2.13,4.09-12.26,60.52-8.19,66.09,5.11,7,31.39,21.63,43.26,21.95A20.61,20.61,0,0,0,104.47,415c2.69-4.14,3-62.81.23-67.92C100.14,338.82,73.9,327.69,67.36,327.2Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.36,327.2c-5.14-.38-13.26,4.74-15.3,8.63-2.13,4.09-12.26,60.52-8.19,66.09,5.11,7,31.39,21.63,43.26,21.95A20.61,20.61,0,0,0,104.47,415c2.69-4.14,3-62.81.23-67.92C100.14,338.82,73.9,327.69,67.36,327.2Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.65,377c0-2.46,0-4.88-.08-7.23,0-.94,0-1.87-.06-2.78,0-1.82-.1-3.58-.17-5.25,0-.83-.07-1.65-.11-2.43-.06-1.18-.13-2.3-.2-3.35s-.15-2-.24-2.93l-.09-.87a17.17,17.17,0,0,0-1-5c-.13-.23-.28-.47-.44-.7l-.17-.24-.37-.48-.23-.29-.41-.46-.27-.29-.66-.65c-.15-.15-.31-.29-.47-.43l-.32-.29-.54-.46-.28-.23-.63-.51c-4.73,1.66-5.27,1.39-5.4,1.47-.29.16-5.15,2.71-5.34,9.91L87.5,382.49l-.17,2.76c-.16,3.86-5.55,39.21,5.45,37.8l.44,0c7.47-2.17,10-6,11.25-8a6.18,6.18,0,0,0,.58-1.92c.08-.37.15-.79.22-1.26,0-.23.06-.47.1-.72.09-.75.19-1.6.27-2.52,0-.31.06-.62.09-.95.42-4.87.7-11.63.83-18.87,0-1.45,0-2.92.07-4.39,0-1,0-2,0-3v-1.48C106.66,378.94,106.66,378,106.65,377Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.49,350.38a11.45,11.45,0,0,0-.79-3.29c-4.56-8.27-30.8-19.4-37.34-19.89-5.14-.38-13.26,4.74-15.3,8.63A31.92,31.92,0,0,0,50.6,341c10,6.05,35.78,19.71,38.57,18.87,3.42-1,16-9,16.31-9.47Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.34,391.93c-5.3-2.87-17-10.46-20.31-12.2a3.68,3.68,0,0,0-3.73-.22c-.5.31-2.23,1.4-2.68,1.65a2.46,2.46,0,0,0-1.27,2c-.43,6.14-.71,8.66-.61,11.63.07,2,.33,3.85,3.18,6.16s15.25,9.85,18.94,11.89c3.47,1.92,7.21,3.41,8.81,2.35.41-.28,2.29-1.37,2.79-1.7a2,2,0,0,0,.79-1.68c.13-3.14.61-9.84.76-12.13C82.19,396.87,80.94,395,75.34,391.93Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.34,391.93c-5.3-2.87-17-10.46-20.31-12.2a3.68,3.68,0,0,0-3.73-.22c-.5.31-2.23,1.4-2.68,1.65a2.46,2.46,0,0,0-1.27,2c-.43,6.14-.71,8.66-.61,11.63.07,2,.33,3.85,3.18,6.16s15.25,9.85,18.94,11.89c3.47,1.92,7.21,3.41,8.81,2.35.41-.28,2.29-1.37,2.79-1.7a2,2,0,0,0,.79-1.68c.13-3.14.61-9.84.76-12.13C82.19,396.87,80.94,395,75.34,391.93Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.83,398.81l2.83-1.57c-.69-1.69-2.48-3.24-6.32-5.31-5.3-2.87-17-10.46-20.31-12.2a3.68,3.68,0,0,0-3.73-.22c-.5.31-2.23,1.4-2.68,1.65a2.46,2.46,0,0,0-1.15,1.39Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.35,383.17c-.43,6.14-.71,8.66-.61,11.63.07,2,.33,3.85,3.18,6.16s15.25,9.85,18.94,11.89c4.51,2.49,9.48,4.27,9.62.67.13-3.14.61-9.85.75-12.13.19-2.82-1.07-4.74-6.66-7.77-5.3-2.86-17-10.45-20.31-12.2C49.5,380,47.48,381.33,47.35,383.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.35,383.17c-.43,6.14-.71,8.66-.61,11.63.07,2,.33,3.85,3.18,6.16s15.25,9.85,18.94,11.89c4.51,2.49,9.48,4.27,9.62.67.13-3.14.61-9.85.75-12.13.19-2.82-1.07-4.74-6.66-7.77-5.3-2.86-17-10.45-20.31-12.2C49.5,380,47.48,381.33,47.35,383.17Z",
    style: {
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66,397.24c-.54-1.63-3.24-.56-3.87,1.57s-.62,5-.93,5.89-29.35-16.38-30.14-17.36c-.37-.45.09-5.62,1.16-6.54s3.54-2.53,5.15-2.18,19.23,11,22.68,12.84S81.87,395.23,81.66,397.24Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.66,397.24c-.54-1.63-3.24-.56-3.87,1.57s-.62,5-.93,5.89-29.35-16.38-30.14-17.36c-.37-.45.09-5.62,1.16-6.54s3.54-2.53,5.15-2.18,19.23,11,22.68,12.84S81.87,395.23,81.66,397.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.86,402.64l3.51,1.91a.64.64,0,0,0,1-.43l.44-1.78a1,1,0,0,0-.45-1l-3.52-2a.62.62,0,0,0-1,.42l-.46,1.85A1,1,0,0,0,67.86,402.64Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.55,392.28l3.51,1.92a.65.65,0,0,0,1-.43l.44-1.78a1,1,0,0,0-.45-1.05l-3.52-2a.63.63,0,0,0-1,.42l-.46,1.86A1,1,0,0,0,50.55,392.28Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.85,367c.68-4.45,1.08-7.5,1.83-11.24,1.45-1,3.47-2.3,3.47-2.3l12.53,4.4L75.41,362l2.66.93c.83.3,1.67.82,2.5,1.05,2.14.58,5.34-1.15,7-2.39s2.63-2.4,4.69-2.84q-.44,6.09-1,12.17c-.34,3.81-.4,7.68-1.71,11.29A5.92,5.92,0,0,1,85.43,386a17,17,0,0,1-6.86-.06s-.33,3.42-.71,5.11a5.15,5.15,0,0,1-3,2.63c-2-.52-2-9.79-2-9.79L58,375.78s-.53,3.33-1,5c-.83,1.29-2.43,2.7-3,2.55-2.49-.64-1.4-10.61-1.4-10.61S48.06,370.18,45.85,367Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.83,327.17c-5.65-.35-12.07,3-15.21,7.24s-7.32,25.76-5.45,29.69,17.18,13,26.47,17.46c7.43,3.59,11.31,2.75,14.29,1.27,2.24-1.11,2.32-4.75,2.61-7.44.77-6.94,1.76-19.39,6.21-23.22s8.65-4.94,9.73-1.78c0,0,1.53-4.55-6.87-9.56C84.7,332.53,73.78,327.6,66.83,327.17Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.83,327.17c-5.65-.35-12.07,3-15.21,7.24s-7.32,25.76-5.45,29.69,17.18,13,26.47,17.46c7.43,3.59,11.31,2.75,14.29,1.27,2.24-1.11,2.32-4.75,2.61-7.44.77-6.94,1.76-19.39,6.21-23.22s8.65-4.94,9.73-1.78c0,0,1.53-4.55-6.87-9.56C84.7,332.53,73.78,327.6,66.83,327.17Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.06,347.17l5.34-3.05a1.14,1.14,0,0,1,1.56.43l5.48,9.52a1.14,1.14,0,0,1-.42,1.56l-5.27,3.08a1.15,1.15,0,0,1-1.56-.42l-5.54-9.57A1.13,1.13,0,0,1,63.06,347.17Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.79,357.62l-5.26-9.07a.57.57,0,0,1,.21-.78L68.58,345a.57.57,0,0,1,.78.21l5.2,9a.58.58,0,0,1-.21.78l-4.78,2.79A.57.57,0,0,1,68.79,357.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.66,353.28h0a1,1,0,0,1-.5-.8v-4.34c0-.28.22-.38.5-.21h0a1,1,0,0,1,.51.79v4.34C68.17,353.34,67.94,353.44,67.66,353.28Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.49,354.91h0a1.05,1.05,0,0,1-.51-.8v-4.34c0-.28.23-.38.51-.21h0a1,1,0,0,1,.5.8v4.34C71,355,70.77,355.07,70.49,354.91Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.66,369.8,78.57,372S77,384.2,76.65,390.21c0,0-1.34,2.51-2.46,2.87s-2.38-2.63-2.48-4.81S72.8,375,73.66,369.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.44,371l5,2.09a.87.87,0,0,0,1.26-.71l.35-2.47a1.35,1.35,0,0,0-.76-1.36l-5-2.17a.85.85,0,0,0-1.24.7l-.36,2.58A1.34,1.34,0,0,0,73.44,371Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.31,385.86a2.46,2.46,0,0,1,1.27,2.23,1,1,0,0,1-1.47,1,2.45,2.45,0,0,1-1.27-2.23C72.9,385.92,73.56,385.5,74.31,385.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.36,359.57l4.8,2.48s-1.42,12-2.09,18c0,0-1.46,2.44-2.6,2.74s-2.24-2.75-2.23-4.94A145.35,145.35,0,0,1,53.36,359.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.08,360.74l4.9,2.35a.88.88,0,0,0,1.3-.66l.47-2.44a1.32,1.32,0,0,0-.69-1.39l-4.91-2.43a.85.85,0,0,0-1.28.63l-.48,2.56A1.35,1.35,0,0,0,53.08,360.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,375.59a2.47,2.47,0,0,1,1.16,2.29,1,1,0,0,1-1.52.88,2.42,2.42,0,0,1-1.15-2.29C52.55,375.58,53.23,375.19,54,375.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.57,390.1c-.3-.17-4.62-3.79-5.13-4.08-.89-.52-14.73,7.8-16,9.27-.92,1-.46,17.6,0,18.8.16.43,5,3.65,5.13,4.09.46,1.2,15-7.23,16-9.41S111.89,390.86,110.57,390.1Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.57,390.1c-.3-.17-4.62-3.79-5.13-4.08-.89-.52-14.73,7.8-16,9.27-.92,1-.46,17.6,0,18.8.16.43,5,3.65,5.13,4.09.46,1.2,15-7.23,16-9.41S111.89,390.86,110.57,390.1Z",
    style: {
      opacity: 0.18
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.52,399.37c-.92,1-.47,17.6,0,18.81s15-7.23,16-9.41,1.32-17.91,0-18.67C109.68,389.59,95.83,397.91,94.52,399.37Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.45,386c.5.29,4.82,3.91,5.12,4.08-.89-.51-14.74,7.81-16,9.27l-5.13-4.08C90.7,393.82,104.55,385.5,105.45,386Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.52,399.37c-.92,1-.47,17.6,0,18.81s15-7.23,16-9.41,1.32-17.91,0-18.67C109.68,389.59,95.83,397.91,94.52,399.37Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.39,395.29c1-.6,3.92,1.15,5.14,2.32s2.35,6.42,5.62,7.41,8.18-3.14,9.31-5.9,2.6-8.59,1.11-10.78-4.24-3.49-6.65-2.34S89.81,392.72,89.39,395.29Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.39,395.29c1-.6,3.92,1.15,5.14,2.32s2.35,6.42,5.62,7.41,8.18-3.14,9.31-5.9,2.6-8.59,1.11-10.78-4.24-3.49-6.65-2.34S89.81,392.72,89.39,395.29Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.19,398.36a2.49,2.49,0,0,0-1.27,2.22,1,1,0,0,0,1.47,1,2.41,2.41,0,0,0,1.27-2.23C105.61,398.42,105,398,104.19,398.36Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.22,341c.82.48,3.2-.7,3.56-1.29s.45-5.69-1.33-8.51-12.87-8-15.61-7.62a7.63,7.63,0,0,0-5.1,3.25c-.34.73-.71,5.47,0,6.44s3.25-.52,3.47-.93-.83-3.88,1-4.61c1.62-.65,9.35,2.63,12.5,5.28,1.37,1.14,1.3,4,1.24,5.42S88.81,340.73,89.22,341Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.84,327.62c-2-.18-3.8,0-4.27,1.95s-.3,3.74,0,4a4.63,4.63,0,0,0,2.64-1.25c.22-.42-.83-3.88,1-4.61a1.8,1.8,0,0,1,.67-.08Z",
    style: {
      fill: "#37474f"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.41,146.83l-15.23-13.18s-26.57,2.12-38.16-7.91c-10.2-8.83-8.59-25.67,3.8-35,14.34-10.74,53.6-9.23,65.16-.17s12.1,24.48,2.45,34.85c-5.53,5.94-18.86,7.51-18.86,7.51Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.11,148.25l-16.14-14c-2.94.21-27.18,1.6-38.35-8.08a20.1,20.1,0,0,1-6.89-16.26,25.86,25.86,0,0,1,10.73-19.65c14.58-10.93,54-9.49,65.9-.16a23.84,23.84,0,0,1,9.38,17,24.62,24.62,0,0,1-6.86,18.8c-5,5.39-16,7.24-18.66,7.62ZM268.39,133l14.32,12.39-.79-13,.58-.07c.13,0,13.17-1.62,18.48-7.32a23.43,23.43,0,0,0,6.54-17.86A22.63,22.63,0,0,0,298.6,91.1c-11.36-8.9-50.47-10.27-64.41.18A24.6,24.6,0,0,0,224,110a18.88,18.88,0,0,0,6.47,15.29c11.26,9.76,37.44,7.79,37.7,7.77Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.17,108.86a4.4,4.4,0,1,1-4.4-4.4A4.4,4.4,0,0,1,250.17,108.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.16,108.86a4.4,4.4,0,1,1-4.4-4.4A4.4,4.4,0,0,1,270.16,108.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.15,108.86a4.4,4.4,0,1,1-4.4-4.4A4.4,4.4,0,0,1,290.15,108.86Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.25,178.44a33.09,33.09,0,1,0,1.54-46.78A33.13,33.13,0,0,0,73.25,178.44Zm2.17-2A30.12,30.12,0,1,1,118,177.82,30.15,30.15,0,0,1,75.42,176.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.42,176.4a30.12,30.12,0,1,0,1.4-42.57A30.16,30.16,0,0,0,75.42,176.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.56,185.42l-4.38-10.88-8.81,8.24,10.57,5.09A1.92,1.92,0,0,0,127.56,185.42Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bulb--inject-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.35,170.69h10.13a.77.77,0,0,0,0-1.53H92.35a.77.77,0,0,0,0,1.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.59,172.76a.76.76,0,0,1,.76-.76h10.13a.76.76,0,0,1,.76.76,5.83,5.83,0,1,1-11.65,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.74,150a15.75,15.75,0,0,0,7.72,13.49A4.17,4.17,0,0,1,91.53,167a.69.69,0,0,0,.68.68h10.4a.68.68,0,0,0,.69-.68,4.13,4.13,0,0,1,2.08-3.58,15.69,15.69,0,0,0,7.7-13.73,15.87,15.87,0,0,0-14.91-15.4A15.67,15.67,0,0,0,81.74,150Z",
    style: {
      fill: "#BA68C8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.74,150a15.75,15.75,0,0,0,7.72,13.49A4.17,4.17,0,0,1,91.53,167a.69.69,0,0,0,.68.68h10.4a.68.68,0,0,0,.69-.68,4.13,4.13,0,0,1,2.08-3.58,15.69,15.69,0,0,0,7.7-13.73,15.87,15.87,0,0,0-14.91-15.4A15.67,15.67,0,0,0,81.74,150Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M106.33,153.1a1.76,1.76,0,0,0-1.75-1.25,4,4,0,0,0-3,1.92l0,0h0a7.8,7.8,0,0,1-2.23-1.19,8.09,8.09,0,0,1-1-1h0a4.93,4.93,0,0,0,1-4.12,2,2,0,0,0-3.77,0,4.9,4.9,0,0,0,1,4.12h0l0,0a8,8,0,0,1-1,1,7.71,7.71,0,0,1-2.24,1.19h0v0a4,4,0,0,0-3-1.92,1.76,1.76,0,0,0-1.75,1.25,1.49,1.49,0,0,0,.64,1.72,4.9,4.9,0,0,0,3.49.46h0v0a11.77,11.77,0,0,1,.85,2,27.09,27.09,0,0,1,.87,8.84c0,.56,0,1.06,0,1.56v.25h1.31v-1c0-.26,0-.51,0-.77a28.06,28.06,0,0,0-.94-9.28A13,13,0,0,0,94,155l0,0h0a9.13,9.13,0,0,0,2.33-1.29,10.23,10.23,0,0,0,1.09-1l0,0,0,0a9.7,9.7,0,0,0,1.1,1,9.14,9.14,0,0,0,2.32,1.29h0v0a12.44,12.44,0,0,0-.79,1.94,28.19,28.19,0,0,0-.94,9.27c0,.52,0,1,0,1.53v.25h1.3v-.25c0-.44,0-.9,0-1.35v-.17a27.61,27.61,0,0,1,.88-8.88,11.45,11.45,0,0,1,.85-2h0a4.77,4.77,0,0,0,3.48-.46A1.48,1.48,0,0,0,106.33,153.1Zm-14.58,1h-.32a2.9,2.9,0,0,1-1.55-.34c-.14-.11-.17-.17-.15-.25a.51.51,0,0,1,.52-.34,2.37,2.37,0,0,1,1.52.88l0,0Zm5.69-3.6,0,0,0-.05a3.37,3.37,0,0,1-.62-2.58.6.6,0,0,1,.65-.45.61.61,0,0,1,.65.45A3.51,3.51,0,0,1,97.44,150.49Zm7.5,3.26h0a2.87,2.87,0,0,1-1.51.33H103l0,0a2.35,2.35,0,0,1,1.52-.88.48.48,0,0,1,.51.34C105.12,153.58,105.08,153.65,104.94,153.75Z",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome2);
export default __webpack_public_path__ + "static/media/home2.68d1acf483713ffa2d9f1f3a01d97a76.svg";
export { ForwardRef as ReactComponent };